/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
export type BranchDetailResponseStatus = typeof BranchDetailResponseStatus[keyof typeof BranchDetailResponseStatus];


export const BranchDetailResponseStatus = {
  INACTIVE: 'INACTIVE',
  ACTIVE_HEALTHY: 'ACTIVE_HEALTHY',
  ACTIVE_UNHEALTHY: 'ACTIVE_UNHEALTHY',
  COMING_UP: 'COMING_UP',
  UNKNOWN: 'UNKNOWN',
  GOING_DOWN: 'GOING_DOWN',
  INIT_FAILED: 'INIT_FAILED',
  REMOVED: 'REMOVED',
  RESTORING: 'RESTORING',
  UPGRADING: 'UPGRADING',
  PAUSING: 'PAUSING',
  RESTORE_FAILED: 'RESTORE_FAILED',
  RESTARTING: 'RESTARTING',
  PAUSE_FAILED: 'PAUSE_FAILED',
  RESIZING: 'RESIZING',
} as const;

export interface BranchDetailResponse {
  ref: string;
  postgres_version: string;
  postgres_engine: string;
  release_channel: string;
  status: BranchDetailResponseStatus;
  db_host: string;
  /** @exclusiveMinimum 0 */
  db_port: number;
  db_user?: string;
  db_pass?: string;
  jwt_secret?: string;
}

export type UpdateBranchBodyStatus = typeof UpdateBranchBodyStatus[keyof typeof UpdateBranchBodyStatus];


export const UpdateBranchBodyStatus = {
  CREATING_PROJECT: 'CREATING_PROJECT',
  RUNNING_MIGRATIONS: 'RUNNING_MIGRATIONS',
  MIGRATIONS_PASSED: 'MIGRATIONS_PASSED',
  MIGRATIONS_FAILED: 'MIGRATIONS_FAILED',
  FUNCTIONS_DEPLOYED: 'FUNCTIONS_DEPLOYED',
  FUNCTIONS_FAILED: 'FUNCTIONS_FAILED',
} as const;

export interface UpdateBranchBody {
  branch_name?: string;
  git_branch?: string;
  /**
   * This field is deprecated and will be ignored. Use v1-reset-a-branch endpoint directly instead.
   * @deprecated
   */
  reset_on_push?: boolean;
  persistent?: boolean;
  status?: UpdateBranchBodyStatus;
  request_review?: boolean;
  /** HTTP endpoint to receive branch status updates. */
  notify_url?: string;
}

export type BranchResponseStatus = typeof BranchResponseStatus[keyof typeof BranchResponseStatus];


export const BranchResponseStatus = {
  CREATING_PROJECT: 'CREATING_PROJECT',
  RUNNING_MIGRATIONS: 'RUNNING_MIGRATIONS',
  MIGRATIONS_PASSED: 'MIGRATIONS_PASSED',
  MIGRATIONS_FAILED: 'MIGRATIONS_FAILED',
  FUNCTIONS_DEPLOYED: 'FUNCTIONS_DEPLOYED',
  FUNCTIONS_FAILED: 'FUNCTIONS_FAILED',
} as const;

export type BranchResponsePreviewProjectStatus = typeof BranchResponsePreviewProjectStatus[keyof typeof BranchResponsePreviewProjectStatus];


export const BranchResponsePreviewProjectStatus = {
  INACTIVE: 'INACTIVE',
  ACTIVE_HEALTHY: 'ACTIVE_HEALTHY',
  ACTIVE_UNHEALTHY: 'ACTIVE_UNHEALTHY',
  COMING_UP: 'COMING_UP',
  UNKNOWN: 'UNKNOWN',
  GOING_DOWN: 'GOING_DOWN',
  INIT_FAILED: 'INIT_FAILED',
  REMOVED: 'REMOVED',
  RESTORING: 'RESTORING',
  UPGRADING: 'UPGRADING',
  PAUSING: 'PAUSING',
  RESTORE_FAILED: 'RESTORE_FAILED',
  RESTARTING: 'RESTARTING',
  PAUSE_FAILED: 'PAUSE_FAILED',
  RESIZING: 'RESIZING',
} as const;

export interface BranchResponse {
  id: string;
  name: string;
  project_ref: string;
  parent_project_ref: string;
  is_default: boolean;
  git_branch?: string;
  pr_number?: number;
  /**
   * This field is deprecated and will not be populated.
   * @deprecated
   */
  latest_check_run_id?: number;
  persistent: boolean;
  status: BranchResponseStatus;
  created_at: string;
  updated_at: string;
  review_requested_at?: string;
  with_data: boolean;
  notify_url?: string;
  deletion_scheduled_at?: string;
  preview_project_status?: BranchResponsePreviewProjectStatus;
}

export type BranchDeleteResponseMessage = typeof BranchDeleteResponseMessage[keyof typeof BranchDeleteResponseMessage];


export const BranchDeleteResponseMessage = {
  ok: 'ok',
} as const;

export interface BranchDeleteResponse {
  message: BranchDeleteResponseMessage;
}

export interface BranchActionBody {
  migration_version?: string;
}

export type BranchUpdateResponseMessage = typeof BranchUpdateResponseMessage[keyof typeof BranchUpdateResponseMessage];


export const BranchUpdateResponseMessage = {
  ok: 'ok',
} as const;

export interface BranchUpdateResponse {
  workflow_run_id: string;
  message: BranchUpdateResponseMessage;
}

export type BranchRestoreResponseMessage = typeof BranchRestoreResponseMessage[keyof typeof BranchRestoreResponseMessage];


export const BranchRestoreResponseMessage = {
  Branch_restoration_initiated: 'Branch restoration initiated',
} as const;

export interface BranchRestoreResponse {
  message: BranchRestoreResponseMessage;
}

export type V1ListProjectsPaginatedResponseProjectsItemInfraComputeSize = typeof V1ListProjectsPaginatedResponseProjectsItemInfraComputeSize[keyof typeof V1ListProjectsPaginatedResponseProjectsItemInfraComputeSize];


export const V1ListProjectsPaginatedResponseProjectsItemInfraComputeSize = {
  pico: 'pico',
  nano: 'nano',
  micro: 'micro',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge',
  '2xlarge': '2xlarge',
  '4xlarge': '4xlarge',
  '8xlarge': '8xlarge',
  '12xlarge': '12xlarge',
  '16xlarge': '16xlarge',
  '24xlarge': '24xlarge',
  '24xlarge_optimized_memory': '24xlarge_optimized_memory',
  '24xlarge_optimized_cpu': '24xlarge_optimized_cpu',
  '24xlarge_high_memory': '24xlarge_high_memory',
  '48xlarge': '48xlarge',
  '48xlarge_optimized_memory': '48xlarge_optimized_memory',
  '48xlarge_optimized_cpu': '48xlarge_optimized_cpu',
  '48xlarge_high_memory': '48xlarge_high_memory',
} as const;

export type V1ListProjectsPaginatedResponseProjectsItem = {
  id: number;
  cloud_provider: string;
  /** @nullable */
  inserted_at: string | null;
  name: string;
  organization_id: number;
  organization_slug: string;
  ref: string;
  region: string;
  status: string;
  /** @nullable */
  subscription_id: string | null;
  is_branch_enabled: boolean;
  /** @nullable */
  is_physical_backups_enabled: boolean | null;
  preview_branch_refs: string[];
  disk_volume_size_gb?: number;
  infra_compute_size?: V1ListProjectsPaginatedResponseProjectsItemInfraComputeSize;
};

export type V1ListProjectsPaginatedResponsePagination = {
  /** Total number of projects. Use this to calculate the total number of pages. */
  count: number;
  /** Maximum number of projects per page (actual number may be less) */
  limit: number;
  /** Number of projects skipped in this response */
  offset: number;
};

export interface V1ListProjectsPaginatedResponse {
  projects: V1ListProjectsPaginatedResponseProjectsItem[];
  pagination: V1ListProjectsPaginatedResponsePagination;
}

export type V1ProjectWithDatabaseResponseStatus = typeof V1ProjectWithDatabaseResponseStatus[keyof typeof V1ProjectWithDatabaseResponseStatus];


export const V1ProjectWithDatabaseResponseStatus = {
  INACTIVE: 'INACTIVE',
  ACTIVE_HEALTHY: 'ACTIVE_HEALTHY',
  ACTIVE_UNHEALTHY: 'ACTIVE_UNHEALTHY',
  COMING_UP: 'COMING_UP',
  UNKNOWN: 'UNKNOWN',
  GOING_DOWN: 'GOING_DOWN',
  INIT_FAILED: 'INIT_FAILED',
  REMOVED: 'REMOVED',
  RESTORING: 'RESTORING',
  UPGRADING: 'UPGRADING',
  PAUSING: 'PAUSING',
  RESTORE_FAILED: 'RESTORE_FAILED',
  RESTARTING: 'RESTARTING',
  PAUSE_FAILED: 'PAUSE_FAILED',
  RESIZING: 'RESIZING',
} as const;

export type V1ProjectWithDatabaseResponseDatabase = {
  /** Database host */
  host: string;
  /** Database version */
  version: string;
  /** Database engine */
  postgres_engine: string;
  /** Release channel */
  release_channel: string;
};

export interface V1ProjectWithDatabaseResponse {
  /**
   * Deprecated: Use `ref` instead.
   * @deprecated
   */
  id: string;
  /**
   * Project ref
   * @minLength 20
   * @maxLength 20
   * @pattern ^[a-z]+$
   */
  ref: string;
  /**
   * Deprecated: Use `organization_slug` instead.
   * @deprecated
   */
  organization_id: string;
  /**
   * Organization slug
   * @pattern ^[\w-]+$
   */
  organization_slug: string;
  /** Name of your project */
  name: string;
  /** Region of your project */
  region: string;
  /** Creation timestamp */
  created_at: string;
  status: V1ProjectWithDatabaseResponseStatus;
  database: V1ProjectWithDatabaseResponseDatabase;
}

/**
 * Subscription Plan is now set on organization level and is ignored in this request
 * @deprecated
 */
export type V1CreateProjectBodyPlan = typeof V1CreateProjectBodyPlan[keyof typeof V1CreateProjectBodyPlan];


export const V1CreateProjectBodyPlan = {
  free: 'free',
  pro: 'pro',
} as const;

/**
 * Region you want your server to reside in. Use region_selection instead.
 * @deprecated
 */
export type V1CreateProjectBodyRegion = typeof V1CreateProjectBodyRegion[keyof typeof V1CreateProjectBodyRegion];


export const V1CreateProjectBodyRegion = {
  'us-east-1': 'us-east-1',
  'us-east-2': 'us-east-2',
  'us-west-1': 'us-west-1',
  'us-west-2': 'us-west-2',
  'ap-east-1': 'ap-east-1',
  'ap-southeast-1': 'ap-southeast-1',
  'ap-northeast-1': 'ap-northeast-1',
  'ap-northeast-2': 'ap-northeast-2',
  'ap-southeast-2': 'ap-southeast-2',
  'eu-west-1': 'eu-west-1',
  'eu-west-2': 'eu-west-2',
  'eu-west-3': 'eu-west-3',
  'eu-north-1': 'eu-north-1',
  'eu-central-1': 'eu-central-1',
  'eu-central-2': 'eu-central-2',
  'ca-central-1': 'ca-central-1',
  'ap-south-1': 'ap-south-1',
  'sa-east-1': 'sa-east-1',
} as const;

/**
 * Region selection. Only one of region or region_selection can be specified.
 */
export type V1CreateProjectBodyRegionSelection = {
  type: 'specific';
  /**
   * Specific region code. The codes supported are not a stable API, and should be retrieved from the /available-regions endpoint.
   * @minLength 1
   */
  code: 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2' | 'ap-east-1' | 'ap-southeast-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-southeast-2' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'eu-north-1' | 'eu-central-1' | 'eu-central-2' | 'ca-central-1' | 'ap-south-1' | 'sa-east-1';
} | {
  type: 'smartGroup';
  /** The Smart Region Group's code. The codes supported are not a stable API, and should be retrieved from the /available-regions endpoint. */
  code: 'americas' | 'emea' | 'apac';
};

export type V1CreateProjectBodyDesiredInstanceSize = typeof V1CreateProjectBodyDesiredInstanceSize[keyof typeof V1CreateProjectBodyDesiredInstanceSize];


export const V1CreateProjectBodyDesiredInstanceSize = {
  pico: 'pico',
  nano: 'nano',
  micro: 'micro',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge',
  '2xlarge': '2xlarge',
  '4xlarge': '4xlarge',
  '8xlarge': '8xlarge',
  '12xlarge': '12xlarge',
  '16xlarge': '16xlarge',
  '24xlarge': '24xlarge',
  '24xlarge_optimized_memory': '24xlarge_optimized_memory',
  '24xlarge_optimized_cpu': '24xlarge_optimized_cpu',
  '24xlarge_high_memory': '24xlarge_high_memory',
  '48xlarge': '48xlarge',
  '48xlarge_optimized_memory': '48xlarge_optimized_memory',
  '48xlarge_optimized_cpu': '48xlarge_optimized_cpu',
  '48xlarge_high_memory': '48xlarge_high_memory',
} as const;

/**
 * Release channel. If not provided, GA will be used.
 * @deprecated
 */
export type V1CreateProjectBodyReleaseChannel = typeof V1CreateProjectBodyReleaseChannel[keyof typeof V1CreateProjectBodyReleaseChannel];


export const V1CreateProjectBodyReleaseChannel = {
  internal: 'internal',
  alpha: 'alpha',
  beta: 'beta',
  ga: 'ga',
  withdrawn: 'withdrawn',
  preview: 'preview',
} as const;

/**
 * Postgres engine version. If not provided, the latest version will be used.
 * @deprecated
 */
export type V1CreateProjectBodyPostgresEngine = typeof V1CreateProjectBodyPostgresEngine[keyof typeof V1CreateProjectBodyPostgresEngine];


export const V1CreateProjectBodyPostgresEngine = {
  NUMBER_15: '15',
  NUMBER_17: '17',
  '17-oriole': '17-oriole',
} as const;

export interface V1CreateProjectBody {
  /** Database password */
  db_pass: string;
  /**
   * Name of your project
   * @maxLength 256
   */
  name: string;
  /**
   * Deprecated: Use `organization_slug` instead.
   * @deprecated
   */
  organization_id?: string;
  /**
   * Organization slug
   * @pattern ^[\w-]+$
   */
  organization_slug: string;
  /**
   * Subscription Plan is now set on organization level and is ignored in this request
   * @deprecated
   */
  plan?: V1CreateProjectBodyPlan;
  /**
   * Region you want your server to reside in. Use region_selection instead.
   * @deprecated
   */
  region?: V1CreateProjectBodyRegion;
  /** Region selection. Only one of region or region_selection can be specified. */
  region_selection?: V1CreateProjectBodyRegionSelection;
  /**
   * This field is deprecated and is ignored in this request
   * @deprecated
   */
  kps_enabled?: boolean;
  desired_instance_size?: V1CreateProjectBodyDesiredInstanceSize;
  /** Template URL used to create the project from the CLI. */
  template_url?: string;
  /**
   * Release channel. If not provided, GA will be used.
   * @deprecated
   */
  release_channel?: V1CreateProjectBodyReleaseChannel;
  /**
   * Postgres engine version. If not provided, the latest version will be used.
   * @deprecated
   */
  postgres_engine?: V1CreateProjectBodyPostgresEngine;
}

export type V1ProjectResponseStatus = typeof V1ProjectResponseStatus[keyof typeof V1ProjectResponseStatus];


export const V1ProjectResponseStatus = {
  INACTIVE: 'INACTIVE',
  ACTIVE_HEALTHY: 'ACTIVE_HEALTHY',
  ACTIVE_UNHEALTHY: 'ACTIVE_UNHEALTHY',
  COMING_UP: 'COMING_UP',
  UNKNOWN: 'UNKNOWN',
  GOING_DOWN: 'GOING_DOWN',
  INIT_FAILED: 'INIT_FAILED',
  REMOVED: 'REMOVED',
  RESTORING: 'RESTORING',
  UPGRADING: 'UPGRADING',
  PAUSING: 'PAUSING',
  RESTORE_FAILED: 'RESTORE_FAILED',
  RESTARTING: 'RESTARTING',
  PAUSE_FAILED: 'PAUSE_FAILED',
  RESIZING: 'RESIZING',
} as const;

export interface V1ProjectResponse {
  /**
   * Deprecated: Use `ref` instead.
   * @deprecated
   */
  id: string;
  /**
   * Project ref
   * @minLength 20
   * @maxLength 20
   * @pattern ^[a-z]+$
   */
  ref: string;
  /**
   * Deprecated: Use `organization_slug` instead.
   * @deprecated
   */
  organization_id: string;
  /**
   * Organization slug
   * @pattern ^[\w-]+$
   */
  organization_slug: string;
  /** Name of your project */
  name: string;
  /** Region of your project */
  region: string;
  /** Creation timestamp */
  created_at: string;
  status: V1ProjectResponseStatus;
}

export type RegionsInfoRecommendationsSmartGroupCode = typeof RegionsInfoRecommendationsSmartGroupCode[keyof typeof RegionsInfoRecommendationsSmartGroupCode];


export const RegionsInfoRecommendationsSmartGroupCode = {
  americas: 'americas',
  emea: 'emea',
  apac: 'apac',
} as const;

export type RegionsInfoRecommendationsSmartGroupType = typeof RegionsInfoRecommendationsSmartGroupType[keyof typeof RegionsInfoRecommendationsSmartGroupType];


export const RegionsInfoRecommendationsSmartGroupType = {
  smartGroup: 'smartGroup',
} as const;

export type RegionsInfoRecommendationsSmartGroup = {
  name: string;
  code: RegionsInfoRecommendationsSmartGroupCode;
  type: RegionsInfoRecommendationsSmartGroupType;
};

export type RegionsInfoRecommendationsSpecificItemCode = typeof RegionsInfoRecommendationsSpecificItemCode[keyof typeof RegionsInfoRecommendationsSpecificItemCode];


export const RegionsInfoRecommendationsSpecificItemCode = {
  'us-east-1': 'us-east-1',
  'us-east-2': 'us-east-2',
  'us-west-1': 'us-west-1',
  'us-west-2': 'us-west-2',
  'ap-southeast-1': 'ap-southeast-1',
  'ap-northeast-1': 'ap-northeast-1',
  'ap-northeast-2': 'ap-northeast-2',
  'ap-east-1': 'ap-east-1',
  'ap-southeast-2': 'ap-southeast-2',
  'eu-west-1': 'eu-west-1',
  'eu-west-2': 'eu-west-2',
  'eu-west-3': 'eu-west-3',
  'eu-north-1': 'eu-north-1',
  'eu-central-1': 'eu-central-1',
  'eu-central-2': 'eu-central-2',
  'ca-central-1': 'ca-central-1',
  'ap-south-1': 'ap-south-1',
  'sa-east-1': 'sa-east-1',
} as const;

export type RegionsInfoRecommendationsSpecificItemType = typeof RegionsInfoRecommendationsSpecificItemType[keyof typeof RegionsInfoRecommendationsSpecificItemType];


export const RegionsInfoRecommendationsSpecificItemType = {
  specific: 'specific',
} as const;

export type RegionsInfoRecommendationsSpecificItemProvider = typeof RegionsInfoRecommendationsSpecificItemProvider[keyof typeof RegionsInfoRecommendationsSpecificItemProvider];


export const RegionsInfoRecommendationsSpecificItemProvider = {
  AWS: 'AWS',
  FLY: 'FLY',
  AWS_K8S: 'AWS_K8S',
  AWS_NIMBUS: 'AWS_NIMBUS',
} as const;

export type RegionsInfoRecommendationsSpecificItemStatus = typeof RegionsInfoRecommendationsSpecificItemStatus[keyof typeof RegionsInfoRecommendationsSpecificItemStatus];


export const RegionsInfoRecommendationsSpecificItemStatus = {
  capacity: 'capacity',
  other: 'other',
} as const;

export type RegionsInfoRecommendationsSpecificItem = {
  name: string;
  code: RegionsInfoRecommendationsSpecificItemCode;
  type: RegionsInfoRecommendationsSpecificItemType;
  provider: RegionsInfoRecommendationsSpecificItemProvider;
  status?: RegionsInfoRecommendationsSpecificItemStatus;
};

export type RegionsInfoRecommendations = {
  smartGroup: RegionsInfoRecommendationsSmartGroup;
  specific: RegionsInfoRecommendationsSpecificItem[];
};

export type RegionsInfoAllSmartGroupItemCode = typeof RegionsInfoAllSmartGroupItemCode[keyof typeof RegionsInfoAllSmartGroupItemCode];


export const RegionsInfoAllSmartGroupItemCode = {
  americas: 'americas',
  emea: 'emea',
  apac: 'apac',
} as const;

export type RegionsInfoAllSmartGroupItemType = typeof RegionsInfoAllSmartGroupItemType[keyof typeof RegionsInfoAllSmartGroupItemType];


export const RegionsInfoAllSmartGroupItemType = {
  smartGroup: 'smartGroup',
} as const;

export type RegionsInfoAllSmartGroupItem = {
  name: string;
  code: RegionsInfoAllSmartGroupItemCode;
  type: RegionsInfoAllSmartGroupItemType;
};

export type RegionsInfoAllSpecificItemCode = typeof RegionsInfoAllSpecificItemCode[keyof typeof RegionsInfoAllSpecificItemCode];


export const RegionsInfoAllSpecificItemCode = {
  'us-east-1': 'us-east-1',
  'us-east-2': 'us-east-2',
  'us-west-1': 'us-west-1',
  'us-west-2': 'us-west-2',
  'ap-southeast-1': 'ap-southeast-1',
  'ap-northeast-1': 'ap-northeast-1',
  'ap-northeast-2': 'ap-northeast-2',
  'ap-east-1': 'ap-east-1',
  'ap-southeast-2': 'ap-southeast-2',
  'eu-west-1': 'eu-west-1',
  'eu-west-2': 'eu-west-2',
  'eu-west-3': 'eu-west-3',
  'eu-north-1': 'eu-north-1',
  'eu-central-1': 'eu-central-1',
  'eu-central-2': 'eu-central-2',
  'ca-central-1': 'ca-central-1',
  'ap-south-1': 'ap-south-1',
  'sa-east-1': 'sa-east-1',
} as const;

export type RegionsInfoAllSpecificItemType = typeof RegionsInfoAllSpecificItemType[keyof typeof RegionsInfoAllSpecificItemType];


export const RegionsInfoAllSpecificItemType = {
  specific: 'specific',
} as const;

export type RegionsInfoAllSpecificItemProvider = typeof RegionsInfoAllSpecificItemProvider[keyof typeof RegionsInfoAllSpecificItemProvider];


export const RegionsInfoAllSpecificItemProvider = {
  AWS: 'AWS',
  FLY: 'FLY',
  AWS_K8S: 'AWS_K8S',
  AWS_NIMBUS: 'AWS_NIMBUS',
} as const;

export type RegionsInfoAllSpecificItemStatus = typeof RegionsInfoAllSpecificItemStatus[keyof typeof RegionsInfoAllSpecificItemStatus];


export const RegionsInfoAllSpecificItemStatus = {
  capacity: 'capacity',
  other: 'other',
} as const;

export type RegionsInfoAllSpecificItem = {
  name: string;
  code: RegionsInfoAllSpecificItemCode;
  type: RegionsInfoAllSpecificItemType;
  provider: RegionsInfoAllSpecificItemProvider;
  status?: RegionsInfoAllSpecificItemStatus;
};

export type RegionsInfoAll = {
  smartGroup: RegionsInfoAllSmartGroupItem[];
  specific: RegionsInfoAllSpecificItem[];
};

export interface RegionsInfo {
  recommendations: RegionsInfoRecommendations;
  all: RegionsInfoAll;
}

export interface OrganizationResponseV1 {
  /**
   * Deprecated: Use `slug` instead.
   * @deprecated
   */
  id: string;
  /**
   * Organization slug
   * @pattern ^[\w-]+$
   */
  slug: string;
  name: string;
}

export interface CreateOrganizationV1 {
  /** @maxLength 256 */
  name: string;
}

export type OAuthTokenBodyGrantType = typeof OAuthTokenBodyGrantType[keyof typeof OAuthTokenBodyGrantType];


export const OAuthTokenBodyGrantType = {
  authorization_code: 'authorization_code',
  refresh_token: 'refresh_token',
} as const;

export interface OAuthTokenBody {
  grant_type?: OAuthTokenBodyGrantType;
  client_id?: string;
  client_secret?: string;
  code?: string;
  code_verifier?: string;
  redirect_uri?: string;
  refresh_token?: string;
  /** Resource indicator for MCP (Model Context Protocol) clients */
  resource?: string;
  scope?: string;
}

export type OAuthTokenResponseTokenType = typeof OAuthTokenResponseTokenType[keyof typeof OAuthTokenResponseTokenType];


export const OAuthTokenResponseTokenType = {
  Bearer: 'Bearer',
} as const;

export interface OAuthTokenResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: OAuthTokenResponseTokenType;
}

export interface OAuthRevokeTokenBody {
  client_id: string;
  client_secret: string;
  refresh_token: string;
}

export type SnippetListDataItemType = typeof SnippetListDataItemType[keyof typeof SnippetListDataItemType];


export const SnippetListDataItemType = {
  sql: 'sql',
} as const;

export type SnippetListDataItemVisibility = typeof SnippetListDataItemVisibility[keyof typeof SnippetListDataItemVisibility];


export const SnippetListDataItemVisibility = {
  user: 'user',
  project: 'project',
  org: 'org',
  public: 'public',
} as const;

export type SnippetListDataItemProject = {
  id: number;
  name: string;
};

export type SnippetListDataItemOwner = {
  id: number;
  username: string;
};

export type SnippetListDataItemUpdatedBy = {
  id: number;
  username: string;
};

export type SnippetListDataItem = {
  id: string;
  inserted_at: string;
  updated_at: string;
  type: SnippetListDataItemType;
  visibility: SnippetListDataItemVisibility;
  name: string;
  /** @nullable */
  description: string | null;
  project: SnippetListDataItemProject;
  owner: SnippetListDataItemOwner;
  updated_by: SnippetListDataItemUpdatedBy;
  favorite: boolean;
};

export interface SnippetList {
  data: SnippetListDataItem[];
  cursor?: string;
}

export type SnippetResponseType = typeof SnippetResponseType[keyof typeof SnippetResponseType];


export const SnippetResponseType = {
  sql: 'sql',
} as const;

export type SnippetResponseVisibility = typeof SnippetResponseVisibility[keyof typeof SnippetResponseVisibility];


export const SnippetResponseVisibility = {
  user: 'user',
  project: 'project',
  org: 'org',
  public: 'public',
} as const;

export type SnippetResponseProject = {
  id: number;
  name: string;
};

export type SnippetResponseOwner = {
  id: number;
  username: string;
};

export type SnippetResponseUpdatedBy = {
  id: number;
  username: string;
};

export type SnippetResponseContent = {
  /**
   * Deprecated: Rely on root-level favorite property instead.
   * @deprecated
   */
  favorite?: boolean;
  schema_version: string;
  sql: string;
};

export interface SnippetResponse {
  id: string;
  inserted_at: string;
  updated_at: string;
  type: SnippetResponseType;
  visibility: SnippetResponseVisibility;
  name: string;
  /** @nullable */
  description: string | null;
  project: SnippetResponseProject;
  owner: SnippetResponseOwner;
  updated_by: SnippetResponseUpdatedBy;
  favorite: boolean;
  content: SnippetResponseContent;
}

export type ListActionRunResponseItemRunStepsItemName = typeof ListActionRunResponseItemRunStepsItemName[keyof typeof ListActionRunResponseItemRunStepsItemName];


export const ListActionRunResponseItemRunStepsItemName = {
  clone: 'clone',
  pull: 'pull',
  health: 'health',
  configure: 'configure',
  migrate: 'migrate',
  seed: 'seed',
  deploy: 'deploy',
} as const;

export type ListActionRunResponseItemRunStepsItemStatus = typeof ListActionRunResponseItemRunStepsItemStatus[keyof typeof ListActionRunResponseItemRunStepsItemStatus];


export const ListActionRunResponseItemRunStepsItemStatus = {
  CREATED: 'CREATED',
  DEAD: 'DEAD',
  EXITED: 'EXITED',
  PAUSED: 'PAUSED',
  REMOVING: 'REMOVING',
  RESTARTING: 'RESTARTING',
  RUNNING: 'RUNNING',
} as const;

export type ListActionRunResponseItemRunStepsItem = {
  name: ListActionRunResponseItemRunStepsItemName;
  status: ListActionRunResponseItemRunStepsItemStatus;
  created_at: string;
  updated_at: string;
};

export type ListActionRunResponseItem = {
  id: string;
  branch_id: string;
  run_steps: ListActionRunResponseItemRunStepsItem[];
  git_config?: unknown | null;
  /** @nullable */
  workdir: string | null;
  /** @nullable */
  check_run_id: number | null;
  created_at: string;
  updated_at: string;
};

export type ListActionRunResponse = ListActionRunResponseItem[];

export type ActionRunResponseRunStepsItemName = typeof ActionRunResponseRunStepsItemName[keyof typeof ActionRunResponseRunStepsItemName];


export const ActionRunResponseRunStepsItemName = {
  clone: 'clone',
  pull: 'pull',
  health: 'health',
  configure: 'configure',
  migrate: 'migrate',
  seed: 'seed',
  deploy: 'deploy',
} as const;

export type ActionRunResponseRunStepsItemStatus = typeof ActionRunResponseRunStepsItemStatus[keyof typeof ActionRunResponseRunStepsItemStatus];


export const ActionRunResponseRunStepsItemStatus = {
  CREATED: 'CREATED',
  DEAD: 'DEAD',
  EXITED: 'EXITED',
  PAUSED: 'PAUSED',
  REMOVING: 'REMOVING',
  RESTARTING: 'RESTARTING',
  RUNNING: 'RUNNING',
} as const;

export type ActionRunResponseRunStepsItem = {
  name: ActionRunResponseRunStepsItemName;
  status: ActionRunResponseRunStepsItemStatus;
  created_at: string;
  updated_at: string;
};

export interface ActionRunResponse {
  id: string;
  branch_id: string;
  run_steps: ActionRunResponseRunStepsItem[];
  git_config?: unknown | null;
  /** @nullable */
  workdir: string | null;
  /** @nullable */
  check_run_id: number | null;
  created_at: string;
  updated_at: string;
}

export type UpdateRunStatusBodyClone = typeof UpdateRunStatusBodyClone[keyof typeof UpdateRunStatusBodyClone];


export const UpdateRunStatusBodyClone = {
  CREATED: 'CREATED',
  DEAD: 'DEAD',
  EXITED: 'EXITED',
  PAUSED: 'PAUSED',
  REMOVING: 'REMOVING',
  RESTARTING: 'RESTARTING',
  RUNNING: 'RUNNING',
} as const;

export type UpdateRunStatusBodyPull = typeof UpdateRunStatusBodyPull[keyof typeof UpdateRunStatusBodyPull];


export const UpdateRunStatusBodyPull = {
  CREATED: 'CREATED',
  DEAD: 'DEAD',
  EXITED: 'EXITED',
  PAUSED: 'PAUSED',
  REMOVING: 'REMOVING',
  RESTARTING: 'RESTARTING',
  RUNNING: 'RUNNING',
} as const;

export type UpdateRunStatusBodyHealth = typeof UpdateRunStatusBodyHealth[keyof typeof UpdateRunStatusBodyHealth];


export const UpdateRunStatusBodyHealth = {
  CREATED: 'CREATED',
  DEAD: 'DEAD',
  EXITED: 'EXITED',
  PAUSED: 'PAUSED',
  REMOVING: 'REMOVING',
  RESTARTING: 'RESTARTING',
  RUNNING: 'RUNNING',
} as const;

export type UpdateRunStatusBodyConfigure = typeof UpdateRunStatusBodyConfigure[keyof typeof UpdateRunStatusBodyConfigure];


export const UpdateRunStatusBodyConfigure = {
  CREATED: 'CREATED',
  DEAD: 'DEAD',
  EXITED: 'EXITED',
  PAUSED: 'PAUSED',
  REMOVING: 'REMOVING',
  RESTARTING: 'RESTARTING',
  RUNNING: 'RUNNING',
} as const;

export type UpdateRunStatusBodyMigrate = typeof UpdateRunStatusBodyMigrate[keyof typeof UpdateRunStatusBodyMigrate];


export const UpdateRunStatusBodyMigrate = {
  CREATED: 'CREATED',
  DEAD: 'DEAD',
  EXITED: 'EXITED',
  PAUSED: 'PAUSED',
  REMOVING: 'REMOVING',
  RESTARTING: 'RESTARTING',
  RUNNING: 'RUNNING',
} as const;

export type UpdateRunStatusBodySeed = typeof UpdateRunStatusBodySeed[keyof typeof UpdateRunStatusBodySeed];


export const UpdateRunStatusBodySeed = {
  CREATED: 'CREATED',
  DEAD: 'DEAD',
  EXITED: 'EXITED',
  PAUSED: 'PAUSED',
  REMOVING: 'REMOVING',
  RESTARTING: 'RESTARTING',
  RUNNING: 'RUNNING',
} as const;

export type UpdateRunStatusBodyDeploy = typeof UpdateRunStatusBodyDeploy[keyof typeof UpdateRunStatusBodyDeploy];


export const UpdateRunStatusBodyDeploy = {
  CREATED: 'CREATED',
  DEAD: 'DEAD',
  EXITED: 'EXITED',
  PAUSED: 'PAUSED',
  REMOVING: 'REMOVING',
  RESTARTING: 'RESTARTING',
  RUNNING: 'RUNNING',
} as const;

export interface UpdateRunStatusBody {
  clone?: UpdateRunStatusBodyClone;
  pull?: UpdateRunStatusBodyPull;
  health?: UpdateRunStatusBodyHealth;
  configure?: UpdateRunStatusBodyConfigure;
  migrate?: UpdateRunStatusBodyMigrate;
  seed?: UpdateRunStatusBodySeed;
  deploy?: UpdateRunStatusBodyDeploy;
}

export type UpdateRunStatusResponseMessage = typeof UpdateRunStatusResponseMessage[keyof typeof UpdateRunStatusResponseMessage];


export const UpdateRunStatusResponseMessage = {
  ok: 'ok',
} as const;

export interface UpdateRunStatusResponse {
  message: UpdateRunStatusResponseMessage;
}

/**
 * @nullable
 */
export type ApiKeyResponseType = typeof ApiKeyResponseType[keyof typeof ApiKeyResponseType] | null;


export const ApiKeyResponseType = {
  legacy: 'legacy',
  publishable: 'publishable',
  secret: 'secret',
} as const;

/**
 * @nullable
 */
export type ApiKeyResponseSecretJwtTemplate = {[key: string]: unknown} | null;

export interface ApiKeyResponse {
  /** @nullable */
  api_key?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  type?: ApiKeyResponseType;
  /** @nullable */
  prefix?: string | null;
  name: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  hash?: string | null;
  /** @nullable */
  secret_jwt_template?: ApiKeyResponseSecretJwtTemplate;
  /** @nullable */
  inserted_at?: string | null;
  /** @nullable */
  updated_at?: string | null;
}

export interface LegacyApiKeysResponse {
  enabled: boolean;
}

export type CreateApiKeyBodyType = typeof CreateApiKeyBodyType[keyof typeof CreateApiKeyBodyType];


export const CreateApiKeyBodyType = {
  publishable: 'publishable',
  secret: 'secret',
} as const;

/**
 * @nullable
 */
export type CreateApiKeyBodySecretJwtTemplate = {[key: string]: unknown} | null;

export interface CreateApiKeyBody {
  type: CreateApiKeyBodyType;
  /**
   * @minLength 4
   * @maxLength 64
   * @pattern ^[a-z_][a-z0-9_]+$
   */
  name: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  secret_jwt_template?: CreateApiKeyBodySecretJwtTemplate;
}

/**
 * @nullable
 */
export type UpdateApiKeyBodySecretJwtTemplate = {[key: string]: unknown} | null;

export interface UpdateApiKeyBody {
  /**
   * @minLength 4
   * @maxLength 64
   * @pattern ^[a-z_][a-z0-9_]+$
   */
  name?: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  secret_jwt_template?: UpdateApiKeyBodySecretJwtTemplate;
}

export type CreateBranchBodyDesiredInstanceSize = typeof CreateBranchBodyDesiredInstanceSize[keyof typeof CreateBranchBodyDesiredInstanceSize];


export const CreateBranchBodyDesiredInstanceSize = {
  pico: 'pico',
  nano: 'nano',
  micro: 'micro',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge',
  '2xlarge': '2xlarge',
  '4xlarge': '4xlarge',
  '8xlarge': '8xlarge',
  '12xlarge': '12xlarge',
  '16xlarge': '16xlarge',
  '24xlarge': '24xlarge',
  '24xlarge_optimized_memory': '24xlarge_optimized_memory',
  '24xlarge_optimized_cpu': '24xlarge_optimized_cpu',
  '24xlarge_high_memory': '24xlarge_high_memory',
  '48xlarge': '48xlarge',
  '48xlarge_optimized_memory': '48xlarge_optimized_memory',
  '48xlarge_optimized_cpu': '48xlarge_optimized_cpu',
  '48xlarge_high_memory': '48xlarge_high_memory',
} as const;

/**
 * Release channel. If not provided, GA will be used.
 */
export type CreateBranchBodyReleaseChannel = typeof CreateBranchBodyReleaseChannel[keyof typeof CreateBranchBodyReleaseChannel];


export const CreateBranchBodyReleaseChannel = {
  internal: 'internal',
  alpha: 'alpha',
  beta: 'beta',
  ga: 'ga',
  withdrawn: 'withdrawn',
  preview: 'preview',
} as const;

/**
 * Postgres engine version. If not provided, the latest version will be used.
 */
export type CreateBranchBodyPostgresEngine = typeof CreateBranchBodyPostgresEngine[keyof typeof CreateBranchBodyPostgresEngine];


export const CreateBranchBodyPostgresEngine = {
  NUMBER_15: '15',
  NUMBER_17: '17',
  '17-oriole': '17-oriole',
} as const;

export type CreateBranchBodySecrets = {[key: string]: string};

export interface CreateBranchBody {
  /** @minLength 1 */
  branch_name: string;
  git_branch?: string;
  is_default?: boolean;
  persistent?: boolean;
  region?: string;
  desired_instance_size?: CreateBranchBodyDesiredInstanceSize;
  /** Release channel. If not provided, GA will be used. */
  release_channel?: CreateBranchBodyReleaseChannel;
  /** Postgres engine version. If not provided, the latest version will be used. */
  postgres_engine?: CreateBranchBodyPostgresEngine;
  secrets?: CreateBranchBodySecrets;
  with_data?: boolean;
  /** HTTP endpoint to receive branch status updates. */
  notify_url?: string;
}

export type UpdateCustomHostnameResponseStatus = typeof UpdateCustomHostnameResponseStatus[keyof typeof UpdateCustomHostnameResponseStatus];


export const UpdateCustomHostnameResponseStatus = {
  '1_not_started': '1_not_started',
  '2_initiated': '2_initiated',
  '3_challenge_verified': '3_challenge_verified',
  '4_origin_setup_completed': '4_origin_setup_completed',
  '5_services_reconfigured': '5_services_reconfigured',
} as const;

export type UpdateCustomHostnameResponseDataResultSslValidationRecordsItem = {
  txt_name: string;
  txt_value: string;
};

export type UpdateCustomHostnameResponseDataResultSslValidationErrorsItem = {
  message: string;
};

export type UpdateCustomHostnameResponseDataResultSsl = {
  status: string;
  validation_records: UpdateCustomHostnameResponseDataResultSslValidationRecordsItem[];
  validation_errors?: UpdateCustomHostnameResponseDataResultSslValidationErrorsItem[];
};

export type UpdateCustomHostnameResponseDataResultOwnershipVerification = {
  type: string;
  name: string;
  value: string;
};

export type UpdateCustomHostnameResponseDataResult = {
  id: string;
  hostname: string;
  ssl: UpdateCustomHostnameResponseDataResultSsl;
  ownership_verification: UpdateCustomHostnameResponseDataResultOwnershipVerification;
  custom_origin_server: string;
  verification_errors?: string[];
  status: string;
};

export type UpdateCustomHostnameResponseData = {
  success: boolean;
  errors: unknown[];
  messages: unknown[];
  result: UpdateCustomHostnameResponseDataResult;
};

export interface UpdateCustomHostnameResponse {
  status: UpdateCustomHostnameResponseStatus;
  custom_hostname: string;
  data: UpdateCustomHostnameResponseData;
}

export interface UpdateCustomHostnameBody {
  /**
   * @minLength 1
   * @maxLength 253
   */
  custom_hostname: string;
}

export type JitAccessResponseUserRolesItemAllowedNetworksAllowedCidrsItem = {
  cidr: string;
};

export type JitAccessResponseUserRolesItemAllowedNetworksAllowedCidrsV6Item = {
  cidr: string;
};

export type JitAccessResponseUserRolesItemAllowedNetworks = {
  allowed_cidrs?: JitAccessResponseUserRolesItemAllowedNetworksAllowedCidrsItem[];
  allowed_cidrs_v6?: JitAccessResponseUserRolesItemAllowedNetworksAllowedCidrsV6Item[];
};

export type JitAccessResponseUserRolesItem = {
  /** @minLength 1 */
  role: string;
  expires_at?: number;
  allowed_networks?: JitAccessResponseUserRolesItemAllowedNetworks;
};

export interface JitAccessResponse {
  user_id: string;
  user_roles: JitAccessResponseUserRolesItem[];
}

export type JitAccessRequestRequestState = typeof JitAccessRequestRequestState[keyof typeof JitAccessRequestRequestState];


export const JitAccessRequestRequestState = {
  enabled: 'enabled',
  disabled: 'disabled',
  unavailable: 'unavailable',
} as const;

export interface JitAccessRequestRequest {
  state: JitAccessRequestRequestState;
}

export interface NetworkBanResponse {
  banned_ipv4_addresses: string[];
}

export type NetworkBanResponseEnrichedBannedIpv4AddressesItem = {
  banned_address: string;
  identifier: string;
  type: string;
};

export interface NetworkBanResponseEnriched {
  banned_ipv4_addresses: NetworkBanResponseEnrichedBannedIpv4AddressesItem[];
}

export interface RemoveNetworkBanRequest {
  /** List of IP addresses to unban. */
  ipv4_addresses: string[];
  /** Include requester's public IP in the list of addresses to unban. */
  requester_ip?: boolean;
  identifier?: string;
}

export type NetworkRestrictionsResponseEntitlement = typeof NetworkRestrictionsResponseEntitlement[keyof typeof NetworkRestrictionsResponseEntitlement];


export const NetworkRestrictionsResponseEntitlement = {
  disallowed: 'disallowed',
  allowed: 'allowed',
} as const;

/**
 * At any given point in time, this is the config that the user has requested be applied to their project. The `status` field indicates if it has been applied to the project, or is pending. When an updated config is received, the applied config is moved to `old_config`.
 */
export type NetworkRestrictionsResponseConfig = {
  dbAllowedCidrs?: string[];
  dbAllowedCidrsV6?: string[];
};

/**
 * Populated when a new config has been received, but not registered as successfully applied to a project.
 */
export type NetworkRestrictionsResponseOldConfig = {
  dbAllowedCidrs?: string[];
  dbAllowedCidrsV6?: string[];
};

export type NetworkRestrictionsResponseStatus = typeof NetworkRestrictionsResponseStatus[keyof typeof NetworkRestrictionsResponseStatus];


export const NetworkRestrictionsResponseStatus = {
  stored: 'stored',
  applied: 'applied',
} as const;

export interface NetworkRestrictionsResponse {
  entitlement: NetworkRestrictionsResponseEntitlement;
  /** At any given point in time, this is the config that the user has requested be applied to their project. The `status` field indicates if it has been applied to the project, or is pending. When an updated config is received, the applied config is moved to `old_config`. */
  config: NetworkRestrictionsResponseConfig;
  /** Populated when a new config has been received, but not registered as successfully applied to a project. */
  old_config?: NetworkRestrictionsResponseOldConfig;
  status: NetworkRestrictionsResponseStatus;
  updated_at?: string;
  applied_at?: string;
}

export interface NetworkRestrictionsRequest {
  dbAllowedCidrs?: string[];
  dbAllowedCidrsV6?: string[];
}

export type NetworkRestrictionsPatchRequestAdd = {
  dbAllowedCidrs?: string[];
  dbAllowedCidrsV6?: string[];
};

export type NetworkRestrictionsPatchRequestRemove = {
  dbAllowedCidrs?: string[];
  dbAllowedCidrsV6?: string[];
};

export interface NetworkRestrictionsPatchRequest {
  add?: NetworkRestrictionsPatchRequestAdd;
  remove?: NetworkRestrictionsPatchRequestRemove;
}

export type NetworkRestrictionsV2ResponseEntitlement = typeof NetworkRestrictionsV2ResponseEntitlement[keyof typeof NetworkRestrictionsV2ResponseEntitlement];


export const NetworkRestrictionsV2ResponseEntitlement = {
  disallowed: 'disallowed',
  allowed: 'allowed',
} as const;

export type NetworkRestrictionsV2ResponseConfigDbAllowedCidrsItemType = typeof NetworkRestrictionsV2ResponseConfigDbAllowedCidrsItemType[keyof typeof NetworkRestrictionsV2ResponseConfigDbAllowedCidrsItemType];


export const NetworkRestrictionsV2ResponseConfigDbAllowedCidrsItemType = {
  v4: 'v4',
  v6: 'v6',
} as const;

export type NetworkRestrictionsV2ResponseConfigDbAllowedCidrsItem = {
  address: string;
  type: NetworkRestrictionsV2ResponseConfigDbAllowedCidrsItemType;
};

/**
 * At any given point in time, this is the config that the user has requested be applied to their project. The `status` field indicates if it has been applied to the project, or is pending. When an updated config is received, the applied config is moved to `old_config`.
 */
export type NetworkRestrictionsV2ResponseConfig = {
  dbAllowedCidrs?: NetworkRestrictionsV2ResponseConfigDbAllowedCidrsItem[];
};

export type NetworkRestrictionsV2ResponseOldConfigDbAllowedCidrsItemType = typeof NetworkRestrictionsV2ResponseOldConfigDbAllowedCidrsItemType[keyof typeof NetworkRestrictionsV2ResponseOldConfigDbAllowedCidrsItemType];


export const NetworkRestrictionsV2ResponseOldConfigDbAllowedCidrsItemType = {
  v4: 'v4',
  v6: 'v6',
} as const;

export type NetworkRestrictionsV2ResponseOldConfigDbAllowedCidrsItem = {
  address: string;
  type: NetworkRestrictionsV2ResponseOldConfigDbAllowedCidrsItemType;
};

/**
 * Populated when a new config has been received, but not registered as successfully applied to a project.
 */
export type NetworkRestrictionsV2ResponseOldConfig = {
  dbAllowedCidrs?: NetworkRestrictionsV2ResponseOldConfigDbAllowedCidrsItem[];
};

export type NetworkRestrictionsV2ResponseStatus = typeof NetworkRestrictionsV2ResponseStatus[keyof typeof NetworkRestrictionsV2ResponseStatus];


export const NetworkRestrictionsV2ResponseStatus = {
  stored: 'stored',
  applied: 'applied',
} as const;

export interface NetworkRestrictionsV2Response {
  entitlement: NetworkRestrictionsV2ResponseEntitlement;
  /** At any given point in time, this is the config that the user has requested be applied to their project. The `status` field indicates if it has been applied to the project, or is pending. When an updated config is received, the applied config is moved to `old_config`. */
  config: NetworkRestrictionsV2ResponseConfig;
  /** Populated when a new config has been received, but not registered as successfully applied to a project. */
  old_config?: NetworkRestrictionsV2ResponseOldConfig;
  updated_at?: string;
  applied_at?: string;
  status: NetworkRestrictionsV2ResponseStatus;
}

export interface PgsodiumConfigResponse {
  root_key: string;
}

export interface UpdatePgsodiumConfigBody {
  root_key: string;
}

export interface PostgrestConfigWithJWTSecretResponse {
  db_schema: string;
  max_rows: number;
  db_extra_search_path: string;
  /**
   * If `null`, the value is automatically configured based on compute size.
   * @nullable
   */
  db_pool: number | null;
  jwt_secret?: string;
}

export interface V1UpdatePostgrestConfigBody {
  db_extra_search_path?: string;
  db_schema?: string;
  /**
   * @minimum 0
   * @maximum 1000000
   */
  max_rows?: number;
  /**
   * @minimum 0
   * @maximum 1000
   */
  db_pool?: number;
}

export interface V1PostgrestConfigResponse {
  db_schema: string;
  max_rows: number;
  db_extra_search_path: string;
  /**
   * If `null`, the value is automatically configured based on compute size.
   * @nullable
   */
  db_pool: number | null;
}

export interface V1ProjectRefResponse {
  id: number;
  ref: string;
  name: string;
}

export interface V1UpdateProjectBody {
  /**
   * @minLength 1
   * @maxLength 256
   */
  name: string;
}

export interface SecretResponse {
  name: string;
  value: string;
  updated_at?: string;
}

export type CreateSecretBodyItem = {
  /**
   * Secret name must not start with the SUPABASE_ prefix.
   * @maxLength 256
   * @pattern ^(?!SUPABASE_).*
   */
  name: string;
  /** @maxLength 24576 */
  value: string;
};

export type CreateSecretBody = CreateSecretBodyItem[];

export type DeleteSecretsBody = string[];

export type SslEnforcementResponseCurrentConfig = {
  database: boolean;
};

export interface SslEnforcementResponse {
  currentConfig: SslEnforcementResponseCurrentConfig;
  appliedSuccessfully: boolean;
}

export type SslEnforcementRequestRequestedConfig = {
  database: boolean;
};

export interface SslEnforcementRequest {
  requestedConfig: SslEnforcementRequestRequestedConfig;
}

export interface TypescriptResponse {
  types: string;
}

export type VanitySubdomainConfigResponseStatus = typeof VanitySubdomainConfigResponseStatus[keyof typeof VanitySubdomainConfigResponseStatus];


export const VanitySubdomainConfigResponseStatus = {
  'not-used': 'not-used',
  'custom-domain-used': 'custom-domain-used',
  active: 'active',
} as const;

export interface VanitySubdomainConfigResponse {
  status: VanitySubdomainConfigResponseStatus;
  /** @minLength 1 */
  custom_domain?: string;
}

export interface VanitySubdomainBody {
  /** @maxLength 63 */
  vanity_subdomain: string;
}

export interface SubdomainAvailabilityResponse {
  available: boolean;
}

export interface ActivateVanitySubdomainResponse {
  custom_domain: string;
}

export type UpgradeDatabaseBodyReleaseChannel = typeof UpgradeDatabaseBodyReleaseChannel[keyof typeof UpgradeDatabaseBodyReleaseChannel];


export const UpgradeDatabaseBodyReleaseChannel = {
  internal: 'internal',
  alpha: 'alpha',
  beta: 'beta',
  ga: 'ga',
  withdrawn: 'withdrawn',
  preview: 'preview',
} as const;

export interface UpgradeDatabaseBody {
  target_version: string;
  release_channel?: UpgradeDatabaseBodyReleaseChannel;
}

export interface ProjectUpgradeInitiateResponse {
  tracking_id: string;
}

export type ProjectUpgradeEligibilityResponseCurrentAppVersionReleaseChannel = typeof ProjectUpgradeEligibilityResponseCurrentAppVersionReleaseChannel[keyof typeof ProjectUpgradeEligibilityResponseCurrentAppVersionReleaseChannel];


export const ProjectUpgradeEligibilityResponseCurrentAppVersionReleaseChannel = {
  internal: 'internal',
  alpha: 'alpha',
  beta: 'beta',
  ga: 'ga',
  withdrawn: 'withdrawn',
  preview: 'preview',
} as const;

export type ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItemPostgresVersion = typeof ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItemPostgresVersion[keyof typeof ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItemPostgresVersion];


export const ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItemPostgresVersion = {
  NUMBER_13: '13',
  NUMBER_14: '14',
  NUMBER_15: '15',
  NUMBER_17: '17',
  '17-oriole': '17-oriole',
} as const;

export type ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItemReleaseChannel = typeof ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItemReleaseChannel[keyof typeof ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItemReleaseChannel];


export const ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItemReleaseChannel = {
  internal: 'internal',
  alpha: 'alpha',
  beta: 'beta',
  ga: 'ga',
  withdrawn: 'withdrawn',
  preview: 'preview',
} as const;

export type ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItem = {
  postgres_version: ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItemPostgresVersion;
  release_channel: ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItemReleaseChannel;
  app_version: string;
};

export type ProjectUpgradeEligibilityResponseValidationErrorsItem = {
  type: 'objects_depending_on_pg_cron';
  dependents: string[];
} | {
  type: 'indexes_referencing_ll_to_earth';
  schema_name: string;
  table_name: string;
  index_name: string;
} | {
  type: 'function_using_obsolete_lang';
  schema_name: string;
  function_name: string;
  lang_name: string;
} | {
  type: 'unsupported_extension';
  extension_name: string;
} | {
  type: 'unsupported_fdw_handler';
  fdw_name: string;
  fdw_handler_name: string;
} | {
  type: 'unlogged_table_with_persistent_sequence';
  schema_name: string;
  table_name: string;
  sequence_name: string;
} | {
  type: 'user_defined_objects_in_internal_schemas';
  obj_type: 'table' | 'function';
  schema_name: string;
  obj_name: string;
} | {
  type: 'active_replication_slot';
  slot_name: string;
};

export interface ProjectUpgradeEligibilityResponse {
  eligible: boolean;
  current_app_version: string;
  current_app_version_release_channel: ProjectUpgradeEligibilityResponseCurrentAppVersionReleaseChannel;
  latest_app_version: string;
  target_upgrade_versions: ProjectUpgradeEligibilityResponseTargetUpgradeVersionsItem[];
  duration_estimate_hours: number;
  legacy_auth_custom_roles: string[];
  /**
   * Use validation_errors instead.
   * @deprecated
   */
  objects_to_be_dropped: string[];
  /**
   * Use validation_errors instead.
   * @deprecated
   */
  unsupported_extensions: string[];
  /**
   * Use validation_errors instead.
   * @deprecated
   */
  user_defined_objects_in_internal_schemas: string[];
  validation_errors: ProjectUpgradeEligibilityResponseValidationErrorsItem[];
}

/**
 * @nullable
 */
export type DatabaseUpgradeStatusResponseDatabaseUpgradeStatus = {
  initiated_at: string;
  latest_status_at: string;
  target_version: number;
  error?: '1_upgraded_instance_launch_failed' | '2_volume_detachchment_from_upgraded_instance_failed' | '3_volume_attachment_to_original_instance_failed' | '4_data_upgrade_initiation_failed' | '5_data_upgrade_completion_failed' | '6_volume_detachchment_from_original_instance_failed' | '7_volume_attachment_to_upgraded_instance_failed' | '8_upgrade_completion_failed' | '9_post_physical_backup_failed';
  progress?: '0_requested' | '1_started' | '2_launched_upgraded_instance' | '3_detached_volume_from_upgraded_instance' | '4_attached_volume_to_original_instance' | '5_initiated_data_upgrade' | '6_completed_data_upgrade' | '7_detached_volume_from_original_instance' | '8_attached_volume_to_upgraded_instance' | '9_completed_upgrade' | '10_completed_post_physical_backup';
  status: number;
} | null;

export interface DatabaseUpgradeStatusResponse {
  /** @nullable */
  databaseUpgradeStatus: DatabaseUpgradeStatusResponseDatabaseUpgradeStatus;
}

export interface ReadOnlyStatusResponse {
  enabled: boolean;
  override_enabled: boolean;
  override_active_until: string;
}

/**
 * Region you want your read replica to reside in
 */
export type SetUpReadReplicaBodyReadReplicaRegion = typeof SetUpReadReplicaBodyReadReplicaRegion[keyof typeof SetUpReadReplicaBodyReadReplicaRegion];


export const SetUpReadReplicaBodyReadReplicaRegion = {
  'us-east-1': 'us-east-1',
  'us-east-2': 'us-east-2',
  'us-west-1': 'us-west-1',
  'us-west-2': 'us-west-2',
  'ap-east-1': 'ap-east-1',
  'ap-southeast-1': 'ap-southeast-1',
  'ap-northeast-1': 'ap-northeast-1',
  'ap-northeast-2': 'ap-northeast-2',
  'ap-southeast-2': 'ap-southeast-2',
  'eu-west-1': 'eu-west-1',
  'eu-west-2': 'eu-west-2',
  'eu-west-3': 'eu-west-3',
  'eu-north-1': 'eu-north-1',
  'eu-central-1': 'eu-central-1',
  'eu-central-2': 'eu-central-2',
  'ca-central-1': 'ca-central-1',
  'ap-south-1': 'ap-south-1',
  'sa-east-1': 'sa-east-1',
} as const;

export interface SetUpReadReplicaBody {
  /** Region you want your read replica to reside in */
  read_replica_region: SetUpReadReplicaBodyReadReplicaRegion;
}

export interface RemoveReadReplicaBody {
  database_identifier: string;
}

export type V1ServiceHealthResponseName = typeof V1ServiceHealthResponseName[keyof typeof V1ServiceHealthResponseName];


export const V1ServiceHealthResponseName = {
  auth: 'auth',
  db: 'db',
  db_postgres_user: 'db_postgres_user',
  pooler: 'pooler',
  realtime: 'realtime',
  rest: 'rest',
  storage: 'storage',
  pg_bouncer: 'pg_bouncer',
} as const;

export type V1ServiceHealthResponseStatus = typeof V1ServiceHealthResponseStatus[keyof typeof V1ServiceHealthResponseStatus];


export const V1ServiceHealthResponseStatus = {
  COMING_UP: 'COMING_UP',
  ACTIVE_HEALTHY: 'ACTIVE_HEALTHY',
  UNHEALTHY: 'UNHEALTHY',
} as const;

export type V1ServiceHealthResponseInfo = {
  name: 'GoTrue';
  version: string;
  description: string;
} | {
  /**
   * Deprecated. Use `status` instead.
   * @deprecated
   */
  healthy: boolean;
  db_connected: boolean;
  replication_connected: boolean;
  connected_cluster: number;
} | {
  db_schema: string;
};

export interface V1ServiceHealthResponse {
  name: V1ServiceHealthResponseName;
  /**
   * Deprecated. Use `status` instead.
   * @deprecated
   */
  healthy: boolean;
  status: V1ServiceHealthResponseStatus;
  info?: V1ServiceHealthResponseInfo;
  error?: string;
}

export type SigningKeyResponseAlgorithm = typeof SigningKeyResponseAlgorithm[keyof typeof SigningKeyResponseAlgorithm];


export const SigningKeyResponseAlgorithm = {
  EdDSA: 'EdDSA',
  ES256: 'ES256',
  RS256: 'RS256',
  HS256: 'HS256',
} as const;

export type SigningKeyResponseStatus = typeof SigningKeyResponseStatus[keyof typeof SigningKeyResponseStatus];


export const SigningKeyResponseStatus = {
  in_use: 'in_use',
  previously_used: 'previously_used',
  revoked: 'revoked',
  standby: 'standby',
} as const;

export interface SigningKeyResponse {
  id: string;
  algorithm: SigningKeyResponseAlgorithm;
  status: SigningKeyResponseStatus;
  public_jwk?: unknown | null;
  created_at: string;
  updated_at: string;
}

export type CreateSigningKeyBodyAlgorithm = typeof CreateSigningKeyBodyAlgorithm[keyof typeof CreateSigningKeyBodyAlgorithm];


export const CreateSigningKeyBodyAlgorithm = {
  EdDSA: 'EdDSA',
  ES256: 'ES256',
  RS256: 'RS256',
  HS256: 'HS256',
} as const;

export type CreateSigningKeyBodyStatus = typeof CreateSigningKeyBodyStatus[keyof typeof CreateSigningKeyBodyStatus];


export const CreateSigningKeyBodyStatus = {
  in_use: 'in_use',
  standby: 'standby',
} as const;

export type CreateSigningKeyBodyPrivateJwk = {
  kid?: string;
  use?: 'sig';
  /**
   * @minItems 2
   * @maxItems 2
   */
  key_ops?: ('sign' | 'verify')[];
  ext?: boolean;
  kty: 'RSA';
  alg?: 'RS256';
  n: string;
  e: 'AQAB';
  d: string;
  p: string;
  q: string;
  dp: string;
  dq: string;
  qi: string;
} | {
  kid?: string;
  use?: 'sig';
  /**
   * @minItems 2
   * @maxItems 2
   */
  key_ops?: ('sign' | 'verify')[];
  ext?: boolean;
  kty: 'EC';
  alg?: 'ES256';
  crv: 'P-256';
  x: string;
  y: string;
  d: string;
} | {
  kid?: string;
  use?: 'sig';
  /**
   * @minItems 2
   * @maxItems 2
   */
  key_ops?: ('sign' | 'verify')[];
  ext?: boolean;
  kty: 'OKP';
  alg?: 'EdDSA';
  crv: 'Ed25519';
  x: string;
  d: string;
} | {
  kid?: string;
  use?: 'sig';
  /**
   * @minItems 2
   * @maxItems 2
   */
  key_ops?: ('sign' | 'verify')[];
  ext?: boolean;
  kty: 'oct';
  alg?: 'HS256';
  /** @minLength 16 */
  k: string;
};

export interface CreateSigningKeyBody {
  algorithm: CreateSigningKeyBodyAlgorithm;
  status?: CreateSigningKeyBodyStatus;
  private_jwk?: CreateSigningKeyBodyPrivateJwk;
}

export type SigningKeysResponseKeysItemAlgorithm = typeof SigningKeysResponseKeysItemAlgorithm[keyof typeof SigningKeysResponseKeysItemAlgorithm];


export const SigningKeysResponseKeysItemAlgorithm = {
  EdDSA: 'EdDSA',
  ES256: 'ES256',
  RS256: 'RS256',
  HS256: 'HS256',
} as const;

export type SigningKeysResponseKeysItemStatus = typeof SigningKeysResponseKeysItemStatus[keyof typeof SigningKeysResponseKeysItemStatus];


export const SigningKeysResponseKeysItemStatus = {
  in_use: 'in_use',
  previously_used: 'previously_used',
  revoked: 'revoked',
  standby: 'standby',
} as const;

export type SigningKeysResponseKeysItem = {
  id: string;
  algorithm: SigningKeysResponseKeysItemAlgorithm;
  status: SigningKeysResponseKeysItemStatus;
  public_jwk?: unknown | null;
  created_at: string;
  updated_at: string;
};

export interface SigningKeysResponse {
  keys: SigningKeysResponseKeysItem[];
}

export type UpdateSigningKeyBodyStatus = typeof UpdateSigningKeyBodyStatus[keyof typeof UpdateSigningKeyBodyStatus];


export const UpdateSigningKeyBodyStatus = {
  in_use: 'in_use',
  previously_used: 'previously_used',
  revoked: 'revoked',
  standby: 'standby',
} as const;

export interface UpdateSigningKeyBody {
  status: UpdateSigningKeyBodyStatus;
}

/**
 * @nullable
 */
export type AuthConfigResponseDbMaxPoolSizeUnit = typeof AuthConfigResponseDbMaxPoolSizeUnit[keyof typeof AuthConfigResponseDbMaxPoolSizeUnit] | null;


export const AuthConfigResponseDbMaxPoolSizeUnit = {
  connections: 'connections',
  percent: 'percent',
} as const;

/**
 * @nullable
 */
export type AuthConfigResponsePasswordRequiredCharacters = typeof AuthConfigResponsePasswordRequiredCharacters[keyof typeof AuthConfigResponsePasswordRequiredCharacters] | null;


export const AuthConfigResponsePasswordRequiredCharacters = {
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789': 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789',
  'abcdefghijklmnopqrstuvwxyz:ABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789': 'abcdefghijklmnopqrstuvwxyz:ABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789',
  'abcdefghijklmnopqrstuvwxyz:ABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789:!@#$%^&*()_+-=[]{};\'\\:"|<>?,/`~': 'abcdefghijklmnopqrstuvwxyz:ABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789:!@#$%^&*()_+-=[]{};\'\\:"|<>?,./`~',
  '': '',
} as const;

/**
 * @nullable
 */
export type AuthConfigResponseSecurityCaptchaProvider = typeof AuthConfigResponseSecurityCaptchaProvider[keyof typeof AuthConfigResponseSecurityCaptchaProvider] | null;


export const AuthConfigResponseSecurityCaptchaProvider = {
  turnstile: 'turnstile',
  hcaptcha: 'hcaptcha',
} as const;

/**
 * @nullable
 */
export type AuthConfigResponseSmsProvider = typeof AuthConfigResponseSmsProvider[keyof typeof AuthConfigResponseSmsProvider] | null;


export const AuthConfigResponseSmsProvider = {
  messagebird: 'messagebird',
  textlocal: 'textlocal',
  twilio: 'twilio',
  twilio_verify: 'twilio_verify',
  vonage: 'vonage',
} as const;

export interface AuthConfigResponse {
  /** @nullable */
  api_max_request_duration: number | null;
  /** @nullable */
  db_max_pool_size: number | null;
  /** @nullable */
  db_max_pool_size_unit: AuthConfigResponseDbMaxPoolSizeUnit;
  /** @nullable */
  disable_signup: boolean | null;
  /** @nullable */
  external_anonymous_users_enabled: boolean | null;
  /** @nullable */
  external_apple_additional_client_ids: string | null;
  /** @nullable */
  external_apple_client_id: string | null;
  /** @nullable */
  external_apple_email_optional: boolean | null;
  /** @nullable */
  external_apple_enabled: boolean | null;
  /** @nullable */
  external_apple_secret: string | null;
  /** @nullable */
  external_azure_client_id: string | null;
  /** @nullable */
  external_azure_email_optional: boolean | null;
  /** @nullable */
  external_azure_enabled: boolean | null;
  /** @nullable */
  external_azure_secret: string | null;
  /** @nullable */
  external_azure_url: string | null;
  /** @nullable */
  external_bitbucket_client_id: string | null;
  /** @nullable */
  external_bitbucket_email_optional: boolean | null;
  /** @nullable */
  external_bitbucket_enabled: boolean | null;
  /** @nullable */
  external_bitbucket_secret: string | null;
  /** @nullable */
  external_discord_client_id: string | null;
  /** @nullable */
  external_discord_email_optional: boolean | null;
  /** @nullable */
  external_discord_enabled: boolean | null;
  /** @nullable */
  external_discord_secret: string | null;
  /** @nullable */
  external_email_enabled: boolean | null;
  /** @nullable */
  external_facebook_client_id: string | null;
  /** @nullable */
  external_facebook_email_optional: boolean | null;
  /** @nullable */
  external_facebook_enabled: boolean | null;
  /** @nullable */
  external_facebook_secret: string | null;
  /** @nullable */
  external_figma_client_id: string | null;
  /** @nullable */
  external_figma_email_optional: boolean | null;
  /** @nullable */
  external_figma_enabled: boolean | null;
  /** @nullable */
  external_figma_secret: string | null;
  /** @nullable */
  external_github_client_id: string | null;
  /** @nullable */
  external_github_email_optional: boolean | null;
  /** @nullable */
  external_github_enabled: boolean | null;
  /** @nullable */
  external_github_secret: string | null;
  /** @nullable */
  external_gitlab_client_id: string | null;
  /** @nullable */
  external_gitlab_email_optional: boolean | null;
  /** @nullable */
  external_gitlab_enabled: boolean | null;
  /** @nullable */
  external_gitlab_secret: string | null;
  /** @nullable */
  external_gitlab_url: string | null;
  /** @nullable */
  external_google_additional_client_ids: string | null;
  /** @nullable */
  external_google_client_id: string | null;
  /** @nullable */
  external_google_email_optional: boolean | null;
  /** @nullable */
  external_google_enabled: boolean | null;
  /** @nullable */
  external_google_secret: string | null;
  /** @nullable */
  external_google_skip_nonce_check: boolean | null;
  /** @nullable */
  external_kakao_client_id: string | null;
  /** @nullable */
  external_kakao_email_optional: boolean | null;
  /** @nullable */
  external_kakao_enabled: boolean | null;
  /** @nullable */
  external_kakao_secret: string | null;
  /** @nullable */
  external_keycloak_client_id: string | null;
  /** @nullable */
  external_keycloak_email_optional: boolean | null;
  /** @nullable */
  external_keycloak_enabled: boolean | null;
  /** @nullable */
  external_keycloak_secret: string | null;
  /** @nullable */
  external_keycloak_url: string | null;
  /** @nullable */
  external_linkedin_oidc_client_id: string | null;
  /** @nullable */
  external_linkedin_oidc_email_optional: boolean | null;
  /** @nullable */
  external_linkedin_oidc_enabled: boolean | null;
  /** @nullable */
  external_linkedin_oidc_secret: string | null;
  /** @nullable */
  external_slack_oidc_client_id: string | null;
  /** @nullable */
  external_slack_oidc_email_optional: boolean | null;
  /** @nullable */
  external_slack_oidc_enabled: boolean | null;
  /** @nullable */
  external_slack_oidc_secret: string | null;
  /** @nullable */
  external_notion_client_id: string | null;
  /** @nullable */
  external_notion_email_optional: boolean | null;
  /** @nullable */
  external_notion_enabled: boolean | null;
  /** @nullable */
  external_notion_secret: string | null;
  /** @nullable */
  external_phone_enabled: boolean | null;
  /** @nullable */
  external_slack_client_id: string | null;
  /** @nullable */
  external_slack_email_optional: boolean | null;
  /** @nullable */
  external_slack_enabled: boolean | null;
  /** @nullable */
  external_slack_secret: string | null;
  /** @nullable */
  external_spotify_client_id: string | null;
  /** @nullable */
  external_spotify_email_optional: boolean | null;
  /** @nullable */
  external_spotify_enabled: boolean | null;
  /** @nullable */
  external_spotify_secret: string | null;
  /** @nullable */
  external_twitch_client_id: string | null;
  /** @nullable */
  external_twitch_email_optional: boolean | null;
  /** @nullable */
  external_twitch_enabled: boolean | null;
  /** @nullable */
  external_twitch_secret: string | null;
  /** @nullable */
  external_twitter_client_id: string | null;
  /** @nullable */
  external_twitter_email_optional: boolean | null;
  /** @nullable */
  external_twitter_enabled: boolean | null;
  /** @nullable */
  external_twitter_secret: string | null;
  /** @nullable */
  external_x_client_id: string | null;
  /** @nullable */
  external_x_email_optional: boolean | null;
  /** @nullable */
  external_x_enabled: boolean | null;
  /** @nullable */
  external_x_secret: string | null;
  /** @nullable */
  external_workos_client_id: string | null;
  /** @nullable */
  external_workos_enabled: boolean | null;
  /** @nullable */
  external_workos_secret: string | null;
  /** @nullable */
  external_workos_url: string | null;
  /** @nullable */
  external_web3_solana_enabled: boolean | null;
  /** @nullable */
  external_web3_ethereum_enabled: boolean | null;
  /** @nullable */
  external_zoom_client_id: string | null;
  /** @nullable */
  external_zoom_email_optional: boolean | null;
  /** @nullable */
  external_zoom_enabled: boolean | null;
  /** @nullable */
  external_zoom_secret: string | null;
  /** @nullable */
  hook_custom_access_token_enabled: boolean | null;
  /** @nullable */
  hook_custom_access_token_uri: string | null;
  /** @nullable */
  hook_custom_access_token_secrets: string | null;
  /** @nullable */
  hook_mfa_verification_attempt_enabled: boolean | null;
  /** @nullable */
  hook_mfa_verification_attempt_uri: string | null;
  /** @nullable */
  hook_mfa_verification_attempt_secrets: string | null;
  /** @nullable */
  hook_password_verification_attempt_enabled: boolean | null;
  /** @nullable */
  hook_password_verification_attempt_uri: string | null;
  /** @nullable */
  hook_password_verification_attempt_secrets: string | null;
  /** @nullable */
  hook_send_sms_enabled: boolean | null;
  /** @nullable */
  hook_send_sms_uri: string | null;
  /** @nullable */
  hook_send_sms_secrets: string | null;
  /** @nullable */
  hook_send_email_enabled: boolean | null;
  /** @nullable */
  hook_send_email_uri: string | null;
  /** @nullable */
  hook_send_email_secrets: string | null;
  /** @nullable */
  hook_before_user_created_enabled: boolean | null;
  /** @nullable */
  hook_before_user_created_uri: string | null;
  /** @nullable */
  hook_before_user_created_secrets: string | null;
  /** @nullable */
  hook_after_user_created_enabled: boolean | null;
  /** @nullable */
  hook_after_user_created_uri: string | null;
  /** @nullable */
  hook_after_user_created_secrets: string | null;
  /** @nullable */
  jwt_exp: number | null;
  /** @nullable */
  mailer_allow_unverified_email_sign_ins: boolean | null;
  /** @nullable */
  mailer_autoconfirm: boolean | null;
  mailer_otp_exp: number;
  /** @nullable */
  mailer_otp_length: number | null;
  /** @nullable */
  mailer_secure_email_change_enabled: boolean | null;
  /** @nullable */
  mailer_subjects_confirmation: string | null;
  /** @nullable */
  mailer_subjects_email_change: string | null;
  /** @nullable */
  mailer_subjects_invite: string | null;
  /** @nullable */
  mailer_subjects_magic_link: string | null;
  /** @nullable */
  mailer_subjects_reauthentication: string | null;
  /** @nullable */
  mailer_subjects_recovery: string | null;
  /** @nullable */
  mailer_subjects_password_changed_notification: string | null;
  /** @nullable */
  mailer_subjects_email_changed_notification: string | null;
  /** @nullable */
  mailer_subjects_phone_changed_notification: string | null;
  /** @nullable */
  mailer_subjects_mfa_factor_enrolled_notification: string | null;
  /** @nullable */
  mailer_subjects_mfa_factor_unenrolled_notification: string | null;
  /** @nullable */
  mailer_subjects_identity_linked_notification: string | null;
  /** @nullable */
  mailer_subjects_identity_unlinked_notification: string | null;
  /** @nullable */
  mailer_templates_confirmation_content: string | null;
  /** @nullable */
  mailer_templates_email_change_content: string | null;
  /** @nullable */
  mailer_templates_invite_content: string | null;
  /** @nullable */
  mailer_templates_magic_link_content: string | null;
  /** @nullable */
  mailer_templates_reauthentication_content: string | null;
  /** @nullable */
  mailer_templates_recovery_content: string | null;
  /** @nullable */
  mailer_templates_password_changed_notification_content: string | null;
  /** @nullable */
  mailer_templates_email_changed_notification_content: string | null;
  /** @nullable */
  mailer_templates_phone_changed_notification_content: string | null;
  /** @nullable */
  mailer_templates_mfa_factor_enrolled_notification_content: string | null;
  /** @nullable */
  mailer_templates_mfa_factor_unenrolled_notification_content: string | null;
  /** @nullable */
  mailer_templates_identity_linked_notification_content: string | null;
  /** @nullable */
  mailer_templates_identity_unlinked_notification_content: string | null;
  /** @nullable */
  mailer_notifications_password_changed_enabled: boolean | null;
  /** @nullable */
  mailer_notifications_email_changed_enabled: boolean | null;
  /** @nullable */
  mailer_notifications_phone_changed_enabled: boolean | null;
  /** @nullable */
  mailer_notifications_mfa_factor_enrolled_enabled: boolean | null;
  /** @nullable */
  mailer_notifications_mfa_factor_unenrolled_enabled: boolean | null;
  /** @nullable */
  mailer_notifications_identity_linked_enabled: boolean | null;
  /** @nullable */
  mailer_notifications_identity_unlinked_enabled: boolean | null;
  /** @nullable */
  mfa_max_enrolled_factors: number | null;
  /** @nullable */
  mfa_totp_enroll_enabled: boolean | null;
  /** @nullable */
  mfa_totp_verify_enabled: boolean | null;
  /** @nullable */
  mfa_phone_enroll_enabled: boolean | null;
  /** @nullable */
  mfa_phone_verify_enabled: boolean | null;
  /** @nullable */
  mfa_web_authn_enroll_enabled: boolean | null;
  /** @nullable */
  mfa_web_authn_verify_enabled: boolean | null;
  mfa_phone_otp_length: number;
  /** @nullable */
  mfa_phone_template: string | null;
  /** @nullable */
  mfa_phone_max_frequency: number | null;
  /** @nullable */
  nimbus_oauth_client_id: string | null;
  /** @nullable */
  nimbus_oauth_email_optional: boolean | null;
  /** @nullable */
  nimbus_oauth_client_secret: string | null;
  /** @nullable */
  password_hibp_enabled: boolean | null;
  /** @nullable */
  password_min_length: number | null;
  /** @nullable */
  password_required_characters: AuthConfigResponsePasswordRequiredCharacters;
  /** @nullable */
  rate_limit_anonymous_users: number | null;
  /** @nullable */
  rate_limit_email_sent: number | null;
  /** @nullable */
  rate_limit_sms_sent: number | null;
  /** @nullable */
  rate_limit_token_refresh: number | null;
  /** @nullable */
  rate_limit_verify: number | null;
  /** @nullable */
  rate_limit_otp: number | null;
  /** @nullable */
  rate_limit_web3: number | null;
  /** @nullable */
  refresh_token_rotation_enabled: boolean | null;
  /** @nullable */
  saml_enabled: boolean | null;
  /** @nullable */
  saml_external_url: string | null;
  /** @nullable */
  saml_allow_encrypted_assertions: boolean | null;
  /** @nullable */
  security_sb_forwarded_for_enabled: boolean | null;
  /** @nullable */
  security_captcha_enabled: boolean | null;
  /** @nullable */
  security_captcha_provider: AuthConfigResponseSecurityCaptchaProvider;
  /** @nullable */
  security_captcha_secret: string | null;
  /** @nullable */
  security_manual_linking_enabled: boolean | null;
  /** @nullable */
  security_refresh_token_reuse_interval: number | null;
  /** @nullable */
  security_update_password_require_reauthentication: boolean | null;
  /** @nullable */
  sessions_inactivity_timeout: number | null;
  /** @nullable */
  sessions_single_per_user: boolean | null;
  /** @nullable */
  sessions_tags: string | null;
  /** @nullable */
  sessions_timebox: number | null;
  /** @nullable */
  site_url: string | null;
  /** @nullable */
  sms_autoconfirm: boolean | null;
  /** @nullable */
  sms_max_frequency: number | null;
  /** @nullable */
  sms_messagebird_access_key: string | null;
  /** @nullable */
  sms_messagebird_originator: string | null;
  /** @nullable */
  sms_otp_exp: number | null;
  sms_otp_length: number;
  /** @nullable */
  sms_provider: AuthConfigResponseSmsProvider;
  /** @nullable */
  sms_template: string | null;
  /** @nullable */
  sms_test_otp: string | null;
  /** @nullable */
  sms_test_otp_valid_until: string | null;
  /** @nullable */
  sms_textlocal_api_key: string | null;
  /** @nullable */
  sms_textlocal_sender: string | null;
  /** @nullable */
  sms_twilio_account_sid: string | null;
  /** @nullable */
  sms_twilio_auth_token: string | null;
  /** @nullable */
  sms_twilio_content_sid: string | null;
  /** @nullable */
  sms_twilio_message_service_sid: string | null;
  /** @nullable */
  sms_twilio_verify_account_sid: string | null;
  /** @nullable */
  sms_twilio_verify_auth_token: string | null;
  /** @nullable */
  sms_twilio_verify_message_service_sid: string | null;
  /** @nullable */
  sms_vonage_api_key: string | null;
  /** @nullable */
  sms_vonage_api_secret: string | null;
  /** @nullable */
  sms_vonage_from: string | null;
  /** @nullable */
  smtp_admin_email: string | null;
  /** @nullable */
  smtp_host: string | null;
  /** @nullable */
  smtp_max_frequency: number | null;
  /** @nullable */
  smtp_pass: string | null;
  /** @nullable */
  smtp_port: string | null;
  /** @nullable */
  smtp_sender_name: string | null;
  /** @nullable */
  smtp_user: string | null;
  /** @nullable */
  uri_allow_list: string | null;
  oauth_server_enabled: boolean;
  oauth_server_allow_dynamic_registration: boolean;
  /** @nullable */
  oauth_server_authorization_path: string | null;
}

/**
 * @nullable
 */
export type UpdateAuthConfigBodySecurityCaptchaProvider = typeof UpdateAuthConfigBodySecurityCaptchaProvider[keyof typeof UpdateAuthConfigBodySecurityCaptchaProvider] | null;


export const UpdateAuthConfigBodySecurityCaptchaProvider = {
  turnstile: 'turnstile',
  hcaptcha: 'hcaptcha',
} as const;

/**
 * @nullable
 */
export type UpdateAuthConfigBodyPasswordRequiredCharacters = typeof UpdateAuthConfigBodyPasswordRequiredCharacters[keyof typeof UpdateAuthConfigBodyPasswordRequiredCharacters] | null;


export const UpdateAuthConfigBodyPasswordRequiredCharacters = {
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789': 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789',
  'abcdefghijklmnopqrstuvwxyz:ABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789': 'abcdefghijklmnopqrstuvwxyz:ABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789',
  'abcdefghijklmnopqrstuvwxyz:ABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789:!@#$%^&*()_+-=[]{};\'\\:"|<>?,/`~': 'abcdefghijklmnopqrstuvwxyz:ABCDEFGHIJKLMNOPQRSTUVWXYZ:0123456789:!@#$%^&*()_+-=[]{};\'\\:"|<>?,./`~',
  '': '',
} as const;

/**
 * @nullable
 */
export type UpdateAuthConfigBodySmsProvider = typeof UpdateAuthConfigBodySmsProvider[keyof typeof UpdateAuthConfigBodySmsProvider] | null;


export const UpdateAuthConfigBodySmsProvider = {
  messagebird: 'messagebird',
  textlocal: 'textlocal',
  twilio: 'twilio',
  twilio_verify: 'twilio_verify',
  vonage: 'vonage',
} as const;

/**
 * @nullable
 */
export type UpdateAuthConfigBodyDbMaxPoolSizeUnit = typeof UpdateAuthConfigBodyDbMaxPoolSizeUnit[keyof typeof UpdateAuthConfigBodyDbMaxPoolSizeUnit] | null;


export const UpdateAuthConfigBodyDbMaxPoolSizeUnit = {
  connections: 'connections',
  percent: 'percent',
} as const;

export interface UpdateAuthConfigBody {
  /**
   * @nullable
   * @pattern ^[^,]+$
   */
  site_url?: string | null;
  /** @nullable */
  disable_signup?: boolean | null;
  /**
   * @minimum 0
   * @maximum 604800
   * @nullable
   */
  jwt_exp?: number | null;
  /** @nullable */
  smtp_admin_email?: string | null;
  /** @nullable */
  smtp_host?: string | null;
  /** @nullable */
  smtp_port?: string | null;
  /** @nullable */
  smtp_user?: string | null;
  /** @nullable */
  smtp_pass?: string | null;
  /**
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  smtp_max_frequency?: number | null;
  /** @nullable */
  smtp_sender_name?: string | null;
  /** @nullable */
  mailer_allow_unverified_email_sign_ins?: boolean | null;
  /** @nullable */
  mailer_autoconfirm?: boolean | null;
  /** @nullable */
  mailer_subjects_invite?: string | null;
  /** @nullable */
  mailer_subjects_confirmation?: string | null;
  /** @nullable */
  mailer_subjects_recovery?: string | null;
  /** @nullable */
  mailer_subjects_email_change?: string | null;
  /** @nullable */
  mailer_subjects_magic_link?: string | null;
  /** @nullable */
  mailer_subjects_reauthentication?: string | null;
  /** @nullable */
  mailer_subjects_password_changed_notification?: string | null;
  /** @nullable */
  mailer_subjects_email_changed_notification?: string | null;
  /** @nullable */
  mailer_subjects_phone_changed_notification?: string | null;
  /** @nullable */
  mailer_subjects_mfa_factor_enrolled_notification?: string | null;
  /** @nullable */
  mailer_subjects_mfa_factor_unenrolled_notification?: string | null;
  /** @nullable */
  mailer_subjects_identity_linked_notification?: string | null;
  /** @nullable */
  mailer_subjects_identity_unlinked_notification?: string | null;
  /** @nullable */
  mailer_templates_invite_content?: string | null;
  /** @nullable */
  mailer_templates_confirmation_content?: string | null;
  /** @nullable */
  mailer_templates_recovery_content?: string | null;
  /** @nullable */
  mailer_templates_email_change_content?: string | null;
  /** @nullable */
  mailer_templates_magic_link_content?: string | null;
  /** @nullable */
  mailer_templates_reauthentication_content?: string | null;
  /** @nullable */
  mailer_templates_password_changed_notification_content?: string | null;
  /** @nullable */
  mailer_templates_email_changed_notification_content?: string | null;
  /** @nullable */
  mailer_templates_phone_changed_notification_content?: string | null;
  /** @nullable */
  mailer_templates_mfa_factor_enrolled_notification_content?: string | null;
  /** @nullable */
  mailer_templates_mfa_factor_unenrolled_notification_content?: string | null;
  /** @nullable */
  mailer_templates_identity_linked_notification_content?: string | null;
  /** @nullable */
  mailer_templates_identity_unlinked_notification_content?: string | null;
  /** @nullable */
  mailer_notifications_password_changed_enabled?: boolean | null;
  /** @nullable */
  mailer_notifications_email_changed_enabled?: boolean | null;
  /** @nullable */
  mailer_notifications_phone_changed_enabled?: boolean | null;
  /** @nullable */
  mailer_notifications_mfa_factor_enrolled_enabled?: boolean | null;
  /** @nullable */
  mailer_notifications_mfa_factor_unenrolled_enabled?: boolean | null;
  /** @nullable */
  mailer_notifications_identity_linked_enabled?: boolean | null;
  /** @nullable */
  mailer_notifications_identity_unlinked_enabled?: boolean | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  mfa_max_enrolled_factors?: number | null;
  /** @nullable */
  uri_allow_list?: string | null;
  /** @nullable */
  external_anonymous_users_enabled?: boolean | null;
  /** @nullable */
  external_email_enabled?: boolean | null;
  /** @nullable */
  external_phone_enabled?: boolean | null;
  /** @nullable */
  saml_enabled?: boolean | null;
  /**
   * @nullable
   * @pattern ^[^,]+$
   */
  saml_external_url?: string | null;
  /** @nullable */
  security_sb_forwarded_for_enabled?: boolean | null;
  /** @nullable */
  security_captcha_enabled?: boolean | null;
  /** @nullable */
  security_captcha_provider?: UpdateAuthConfigBodySecurityCaptchaProvider;
  /** @nullable */
  security_captcha_secret?: string | null;
  /**
   * @minimum 0
   * @nullable
   */
  sessions_timebox?: number | null;
  /**
   * @minimum 0
   * @nullable
   */
  sessions_inactivity_timeout?: number | null;
  /** @nullable */
  sessions_single_per_user?: boolean | null;
  /**
   * @nullable
   * @pattern ^\s*([a-zA-Z0-9_-]+(\s*,+\s*)?)*\s*$
   */
  sessions_tags?: string | null;
  /**
   * @minimum 1
   * @maximum 2147483647
   * @nullable
   */
  rate_limit_anonymous_users?: number | null;
  /**
   * @minimum 1
   * @maximum 2147483647
   * @nullable
   */
  rate_limit_email_sent?: number | null;
  /**
   * @minimum 1
   * @maximum 2147483647
   * @nullable
   */
  rate_limit_sms_sent?: number | null;
  /**
   * @minimum 1
   * @maximum 2147483647
   * @nullable
   */
  rate_limit_verify?: number | null;
  /**
   * @minimum 1
   * @maximum 2147483647
   * @nullable
   */
  rate_limit_token_refresh?: number | null;
  /**
   * @minimum 1
   * @maximum 2147483647
   * @nullable
   */
  rate_limit_otp?: number | null;
  /**
   * @minimum 1
   * @maximum 2147483647
   * @nullable
   */
  rate_limit_web3?: number | null;
  /** @nullable */
  mailer_secure_email_change_enabled?: boolean | null;
  /** @nullable */
  refresh_token_rotation_enabled?: boolean | null;
  /** @nullable */
  password_hibp_enabled?: boolean | null;
  /**
   * @minimum 6
   * @maximum 32767
   * @nullable
   */
  password_min_length?: number | null;
  /** @nullable */
  password_required_characters?: UpdateAuthConfigBodyPasswordRequiredCharacters;
  /** @nullable */
  security_manual_linking_enabled?: boolean | null;
  /** @nullable */
  security_update_password_require_reauthentication?: boolean | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  security_refresh_token_reuse_interval?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  mailer_otp_exp?: number;
  /**
   * @minimum 6
   * @maximum 10
   * @nullable
   */
  mailer_otp_length?: number | null;
  /** @nullable */
  sms_autoconfirm?: boolean | null;
  /**
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  sms_max_frequency?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  sms_otp_exp?: number | null;
  /**
   * @minimum 0
   * @maximum 32767
   */
  sms_otp_length?: number;
  /** @nullable */
  sms_provider?: UpdateAuthConfigBodySmsProvider;
  /** @nullable */
  sms_messagebird_access_key?: string | null;
  /** @nullable */
  sms_messagebird_originator?: string | null;
  /**
   * @nullable
   * @pattern ^([0-9]{1,15}=[0-9]+,?)*$
   */
  sms_test_otp?: string | null;
  /** @nullable */
  sms_test_otp_valid_until?: string | null;
  /** @nullable */
  sms_textlocal_api_key?: string | null;
  /** @nullable */
  sms_textlocal_sender?: string | null;
  /** @nullable */
  sms_twilio_account_sid?: string | null;
  /** @nullable */
  sms_twilio_auth_token?: string | null;
  /** @nullable */
  sms_twilio_content_sid?: string | null;
  /** @nullable */
  sms_twilio_message_service_sid?: string | null;
  /** @nullable */
  sms_twilio_verify_account_sid?: string | null;
  /** @nullable */
  sms_twilio_verify_auth_token?: string | null;
  /** @nullable */
  sms_twilio_verify_message_service_sid?: string | null;
  /** @nullable */
  sms_vonage_api_key?: string | null;
  /** @nullable */
  sms_vonage_api_secret?: string | null;
  /** @nullable */
  sms_vonage_from?: string | null;
  /** @nullable */
  sms_template?: string | null;
  /** @nullable */
  hook_mfa_verification_attempt_enabled?: boolean | null;
  /** @nullable */
  hook_mfa_verification_attempt_uri?: string | null;
  /** @nullable */
  hook_mfa_verification_attempt_secrets?: string | null;
  /** @nullable */
  hook_password_verification_attempt_enabled?: boolean | null;
  /** @nullable */
  hook_password_verification_attempt_uri?: string | null;
  /** @nullable */
  hook_password_verification_attempt_secrets?: string | null;
  /** @nullable */
  hook_custom_access_token_enabled?: boolean | null;
  /** @nullable */
  hook_custom_access_token_uri?: string | null;
  /** @nullable */
  hook_custom_access_token_secrets?: string | null;
  /** @nullable */
  hook_send_sms_enabled?: boolean | null;
  /** @nullable */
  hook_send_sms_uri?: string | null;
  /** @nullable */
  hook_send_sms_secrets?: string | null;
  /** @nullable */
  hook_send_email_enabled?: boolean | null;
  /** @nullable */
  hook_send_email_uri?: string | null;
  /** @nullable */
  hook_send_email_secrets?: string | null;
  /** @nullable */
  hook_before_user_created_enabled?: boolean | null;
  /** @nullable */
  hook_before_user_created_uri?: string | null;
  /** @nullable */
  hook_before_user_created_secrets?: string | null;
  /** @nullable */
  hook_after_user_created_enabled?: boolean | null;
  /** @nullable */
  hook_after_user_created_uri?: string | null;
  /** @nullable */
  hook_after_user_created_secrets?: string | null;
  /** @nullable */
  external_apple_enabled?: boolean | null;
  /** @nullable */
  external_apple_client_id?: string | null;
  /** @nullable */
  external_apple_email_optional?: boolean | null;
  /** @nullable */
  external_apple_secret?: string | null;
  /** @nullable */
  external_apple_additional_client_ids?: string | null;
  /** @nullable */
  external_azure_enabled?: boolean | null;
  /** @nullable */
  external_azure_client_id?: string | null;
  /** @nullable */
  external_azure_email_optional?: boolean | null;
  /** @nullable */
  external_azure_secret?: string | null;
  /** @nullable */
  external_azure_url?: string | null;
  /** @nullable */
  external_bitbucket_enabled?: boolean | null;
  /** @nullable */
  external_bitbucket_client_id?: string | null;
  /** @nullable */
  external_bitbucket_email_optional?: boolean | null;
  /** @nullable */
  external_bitbucket_secret?: string | null;
  /** @nullable */
  external_discord_enabled?: boolean | null;
  /** @nullable */
  external_discord_client_id?: string | null;
  /** @nullable */
  external_discord_email_optional?: boolean | null;
  /** @nullable */
  external_discord_secret?: string | null;
  /** @nullable */
  external_facebook_enabled?: boolean | null;
  /** @nullable */
  external_facebook_client_id?: string | null;
  /** @nullable */
  external_facebook_email_optional?: boolean | null;
  /** @nullable */
  external_facebook_secret?: string | null;
  /** @nullable */
  external_figma_enabled?: boolean | null;
  /** @nullable */
  external_figma_client_id?: string | null;
  /** @nullable */
  external_figma_email_optional?: boolean | null;
  /** @nullable */
  external_figma_secret?: string | null;
  /** @nullable */
  external_github_enabled?: boolean | null;
  /** @nullable */
  external_github_client_id?: string | null;
  /** @nullable */
  external_github_email_optional?: boolean | null;
  /** @nullable */
  external_github_secret?: string | null;
  /** @nullable */
  external_gitlab_enabled?: boolean | null;
  /** @nullable */
  external_gitlab_client_id?: string | null;
  /** @nullable */
  external_gitlab_email_optional?: boolean | null;
  /** @nullable */
  external_gitlab_secret?: string | null;
  /** @nullable */
  external_gitlab_url?: string | null;
  /** @nullable */
  external_google_enabled?: boolean | null;
  /** @nullable */
  external_google_client_id?: string | null;
  /** @nullable */
  external_google_email_optional?: boolean | null;
  /** @nullable */
  external_google_secret?: string | null;
  /** @nullable */
  external_google_additional_client_ids?: string | null;
  /** @nullable */
  external_google_skip_nonce_check?: boolean | null;
  /** @nullable */
  external_kakao_enabled?: boolean | null;
  /** @nullable */
  external_kakao_client_id?: string | null;
  /** @nullable */
  external_kakao_email_optional?: boolean | null;
  /** @nullable */
  external_kakao_secret?: string | null;
  /** @nullable */
  external_keycloak_enabled?: boolean | null;
  /** @nullable */
  external_keycloak_client_id?: string | null;
  /** @nullable */
  external_keycloak_email_optional?: boolean | null;
  /** @nullable */
  external_keycloak_secret?: string | null;
  /** @nullable */
  external_keycloak_url?: string | null;
  /** @nullable */
  external_linkedin_oidc_enabled?: boolean | null;
  /** @nullable */
  external_linkedin_oidc_client_id?: string | null;
  /** @nullable */
  external_linkedin_oidc_email_optional?: boolean | null;
  /** @nullable */
  external_linkedin_oidc_secret?: string | null;
  /** @nullable */
  external_slack_oidc_enabled?: boolean | null;
  /** @nullable */
  external_slack_oidc_client_id?: string | null;
  /** @nullable */
  external_slack_oidc_email_optional?: boolean | null;
  /** @nullable */
  external_slack_oidc_secret?: string | null;
  /** @nullable */
  external_notion_enabled?: boolean | null;
  /** @nullable */
  external_notion_client_id?: string | null;
  /** @nullable */
  external_notion_email_optional?: boolean | null;
  /** @nullable */
  external_notion_secret?: string | null;
  /** @nullable */
  external_slack_enabled?: boolean | null;
  /** @nullable */
  external_slack_client_id?: string | null;
  /** @nullable */
  external_slack_email_optional?: boolean | null;
  /** @nullable */
  external_slack_secret?: string | null;
  /** @nullable */
  external_spotify_enabled?: boolean | null;
  /** @nullable */
  external_spotify_client_id?: string | null;
  /** @nullable */
  external_spotify_email_optional?: boolean | null;
  /** @nullable */
  external_spotify_secret?: string | null;
  /** @nullable */
  external_twitch_enabled?: boolean | null;
  /** @nullable */
  external_twitch_client_id?: string | null;
  /** @nullable */
  external_twitch_email_optional?: boolean | null;
  /** @nullable */
  external_twitch_secret?: string | null;
  /** @nullable */
  external_twitter_enabled?: boolean | null;
  /** @nullable */
  external_twitter_client_id?: string | null;
  /** @nullable */
  external_twitter_email_optional?: boolean | null;
  /** @nullable */
  external_twitter_secret?: string | null;
  /** @nullable */
  external_x_enabled?: boolean | null;
  /** @nullable */
  external_x_client_id?: string | null;
  /** @nullable */
  external_x_email_optional?: boolean | null;
  /** @nullable */
  external_x_secret?: string | null;
  /** @nullable */
  external_workos_enabled?: boolean | null;
  /** @nullable */
  external_workos_client_id?: string | null;
  /** @nullable */
  external_workos_secret?: string | null;
  /** @nullable */
  external_workos_url?: string | null;
  /** @nullable */
  external_web3_solana_enabled?: boolean | null;
  /** @nullable */
  external_web3_ethereum_enabled?: boolean | null;
  /** @nullable */
  external_zoom_enabled?: boolean | null;
  /** @nullable */
  external_zoom_client_id?: string | null;
  /** @nullable */
  external_zoom_email_optional?: boolean | null;
  /** @nullable */
  external_zoom_secret?: string | null;
  /** @nullable */
  db_max_pool_size?: number | null;
  /** @nullable */
  db_max_pool_size_unit?: UpdateAuthConfigBodyDbMaxPoolSizeUnit;
  /** @nullable */
  api_max_request_duration?: number | null;
  /** @nullable */
  mfa_totp_enroll_enabled?: boolean | null;
  /** @nullable */
  mfa_totp_verify_enabled?: boolean | null;
  /** @nullable */
  mfa_web_authn_enroll_enabled?: boolean | null;
  /** @nullable */
  mfa_web_authn_verify_enabled?: boolean | null;
  /** @nullable */
  mfa_phone_enroll_enabled?: boolean | null;
  /** @nullable */
  mfa_phone_verify_enabled?: boolean | null;
  /**
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  mfa_phone_max_frequency?: number | null;
  /**
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  mfa_phone_otp_length?: number | null;
  /** @nullable */
  mfa_phone_template?: string | null;
  /** @nullable */
  nimbus_oauth_client_id?: string | null;
  /** @nullable */
  nimbus_oauth_client_secret?: string | null;
  /** @nullable */
  oauth_server_enabled?: boolean | null;
  /** @nullable */
  oauth_server_allow_dynamic_registration?: boolean | null;
  /** @nullable */
  oauth_server_authorization_path?: string | null;
}

export interface CreateThirdPartyAuthBody {
  oidc_issuer_url?: string;
  jwks_url?: string;
  custom_jwks?: unknown;
}

export interface ThirdPartyAuth {
  id: string;
  type: string;
  /** @nullable */
  oidc_issuer_url?: string | null;
  /** @nullable */
  jwks_url?: string | null;
  custom_jwks?: unknown | null;
  resolved_jwks?: unknown | null;
  inserted_at: string;
  updated_at: string;
  /** @nullable */
  resolved_at?: string | null;
}

export type GetProjectAvailableRestoreVersionsResponseAvailableVersionsItemReleaseChannel = typeof GetProjectAvailableRestoreVersionsResponseAvailableVersionsItemReleaseChannel[keyof typeof GetProjectAvailableRestoreVersionsResponseAvailableVersionsItemReleaseChannel];


export const GetProjectAvailableRestoreVersionsResponseAvailableVersionsItemReleaseChannel = {
  internal: 'internal',
  alpha: 'alpha',
  beta: 'beta',
  ga: 'ga',
  withdrawn: 'withdrawn',
  preview: 'preview',
} as const;

export type GetProjectAvailableRestoreVersionsResponseAvailableVersionsItemPostgresEngine = typeof GetProjectAvailableRestoreVersionsResponseAvailableVersionsItemPostgresEngine[keyof typeof GetProjectAvailableRestoreVersionsResponseAvailableVersionsItemPostgresEngine];


export const GetProjectAvailableRestoreVersionsResponseAvailableVersionsItemPostgresEngine = {
  NUMBER_13: '13',
  NUMBER_14: '14',
  NUMBER_15: '15',
  NUMBER_17: '17',
  '17-oriole': '17-oriole',
} as const;

export type GetProjectAvailableRestoreVersionsResponseAvailableVersionsItem = {
  version: string;
  release_channel: GetProjectAvailableRestoreVersionsResponseAvailableVersionsItemReleaseChannel;
  postgres_engine: GetProjectAvailableRestoreVersionsResponseAvailableVersionsItemPostgresEngine;
};

export interface GetProjectAvailableRestoreVersionsResponse {
  available_versions: GetProjectAvailableRestoreVersionsResponseAvailableVersionsItem[];
}

export type ListProjectAddonsResponseSelectedAddonsItemType = typeof ListProjectAddonsResponseSelectedAddonsItemType[keyof typeof ListProjectAddonsResponseSelectedAddonsItemType];


export const ListProjectAddonsResponseSelectedAddonsItemType = {
  custom_domain: 'custom_domain',
  compute_instance: 'compute_instance',
  pitr: 'pitr',
  ipv4: 'ipv4',
  auth_mfa_phone: 'auth_mfa_phone',
  auth_mfa_web_authn: 'auth_mfa_web_authn',
  log_drain: 'log_drain',
} as const;

export const ListProjectAddonsResponseSelectedAddonsItemVariantId = {  ci_micro: 'ci_micro',
  ci_small: 'ci_small',
  ci_medium: 'ci_medium',
  ci_large: 'ci_large',
  ci_xlarge: 'ci_xlarge',
  ci_2xlarge: 'ci_2xlarge',
  ci_4xlarge: 'ci_4xlarge',
  ci_8xlarge: 'ci_8xlarge',
  ci_12xlarge: 'ci_12xlarge',
  ci_16xlarge: 'ci_16xlarge',
  ci_24xlarge: 'ci_24xlarge',
  ci_24xlarge_optimized_cpu: 'ci_24xlarge_optimized_cpu',
  ci_24xlarge_optimized_memory: 'ci_24xlarge_optimized_memory',
  ci_24xlarge_high_memory: 'ci_24xlarge_high_memory',
  ci_48xlarge: 'ci_48xlarge',
  ci_48xlarge_optimized_cpu: 'ci_48xlarge_optimized_cpu',
  ci_48xlarge_optimized_memory: 'ci_48xlarge_optimized_memory',
  ci_48xlarge_high_memory: 'ci_48xlarge_high_memory',
  cd_default: 'cd_default',
  pitr_7: 'pitr_7',
  pitr_14: 'pitr_14',
  pitr_28: 'pitr_28',
  ipv4_default: 'ipv4_default',
  auth_mfa_phone_default: 'auth_mfa_phone_default',
  auth_mfa_web_authn_default: 'auth_mfa_web_authn_default',
  log_drain_default: 'log_drain_default',
} as const
export type ListProjectAddonsResponseSelectedAddonsItemVariantPriceType = typeof ListProjectAddonsResponseSelectedAddonsItemVariantPriceType[keyof typeof ListProjectAddonsResponseSelectedAddonsItemVariantPriceType];


export const ListProjectAddonsResponseSelectedAddonsItemVariantPriceType = {
  fixed: 'fixed',
  usage: 'usage',
} as const;

export type ListProjectAddonsResponseSelectedAddonsItemVariantPriceInterval = typeof ListProjectAddonsResponseSelectedAddonsItemVariantPriceInterval[keyof typeof ListProjectAddonsResponseSelectedAddonsItemVariantPriceInterval];


export const ListProjectAddonsResponseSelectedAddonsItemVariantPriceInterval = {
  monthly: 'monthly',
  hourly: 'hourly',
} as const;

export type ListProjectAddonsResponseSelectedAddonsItemVariantPrice = {
  description: string;
  type: ListProjectAddonsResponseSelectedAddonsItemVariantPriceType;
  interval: ListProjectAddonsResponseSelectedAddonsItemVariantPriceInterval;
  amount: number;
};

export type ListProjectAddonsResponseSelectedAddonsItemVariant = {
  id: typeof ListProjectAddonsResponseSelectedAddonsItemVariantId[keyof typeof ListProjectAddonsResponseSelectedAddonsItemVariantId];
  name: string;
  price: ListProjectAddonsResponseSelectedAddonsItemVariantPrice;
  /** Any JSON-serializable value */
  meta?: unknown;
};

export type ListProjectAddonsResponseSelectedAddonsItem = {
  type: ListProjectAddonsResponseSelectedAddonsItemType;
  variant: ListProjectAddonsResponseSelectedAddonsItemVariant;
};

export type ListProjectAddonsResponseAvailableAddonsItemType = typeof ListProjectAddonsResponseAvailableAddonsItemType[keyof typeof ListProjectAddonsResponseAvailableAddonsItemType];


export const ListProjectAddonsResponseAvailableAddonsItemType = {
  custom_domain: 'custom_domain',
  compute_instance: 'compute_instance',
  pitr: 'pitr',
  ipv4: 'ipv4',
  auth_mfa_phone: 'auth_mfa_phone',
  auth_mfa_web_authn: 'auth_mfa_web_authn',
  log_drain: 'log_drain',
} as const;

export const ListProjectAddonsResponseAvailableAddonsItemVariantsItemId = {  ci_micro: 'ci_micro',
  ci_small: 'ci_small',
  ci_medium: 'ci_medium',
  ci_large: 'ci_large',
  ci_xlarge: 'ci_xlarge',
  ci_2xlarge: 'ci_2xlarge',
  ci_4xlarge: 'ci_4xlarge',
  ci_8xlarge: 'ci_8xlarge',
  ci_12xlarge: 'ci_12xlarge',
  ci_16xlarge: 'ci_16xlarge',
  ci_24xlarge: 'ci_24xlarge',
  ci_24xlarge_optimized_cpu: 'ci_24xlarge_optimized_cpu',
  ci_24xlarge_optimized_memory: 'ci_24xlarge_optimized_memory',
  ci_24xlarge_high_memory: 'ci_24xlarge_high_memory',
  ci_48xlarge: 'ci_48xlarge',
  ci_48xlarge_optimized_cpu: 'ci_48xlarge_optimized_cpu',
  ci_48xlarge_optimized_memory: 'ci_48xlarge_optimized_memory',
  ci_48xlarge_high_memory: 'ci_48xlarge_high_memory',
  cd_default: 'cd_default',
  pitr_7: 'pitr_7',
  pitr_14: 'pitr_14',
  pitr_28: 'pitr_28',
  ipv4_default: 'ipv4_default',
  auth_mfa_phone_default: 'auth_mfa_phone_default',
  auth_mfa_web_authn_default: 'auth_mfa_web_authn_default',
  log_drain_default: 'log_drain_default',
} as const
export type ListProjectAddonsResponseAvailableAddonsItemVariantsItemPriceType = typeof ListProjectAddonsResponseAvailableAddonsItemVariantsItemPriceType[keyof typeof ListProjectAddonsResponseAvailableAddonsItemVariantsItemPriceType];


export const ListProjectAddonsResponseAvailableAddonsItemVariantsItemPriceType = {
  fixed: 'fixed',
  usage: 'usage',
} as const;

export type ListProjectAddonsResponseAvailableAddonsItemVariantsItemPriceInterval = typeof ListProjectAddonsResponseAvailableAddonsItemVariantsItemPriceInterval[keyof typeof ListProjectAddonsResponseAvailableAddonsItemVariantsItemPriceInterval];


export const ListProjectAddonsResponseAvailableAddonsItemVariantsItemPriceInterval = {
  monthly: 'monthly',
  hourly: 'hourly',
} as const;

export type ListProjectAddonsResponseAvailableAddonsItemVariantsItemPrice = {
  description: string;
  type: ListProjectAddonsResponseAvailableAddonsItemVariantsItemPriceType;
  interval: ListProjectAddonsResponseAvailableAddonsItemVariantsItemPriceInterval;
  amount: number;
};

export type ListProjectAddonsResponseAvailableAddonsItemVariantsItem = {
  id: typeof ListProjectAddonsResponseAvailableAddonsItemVariantsItemId[keyof typeof ListProjectAddonsResponseAvailableAddonsItemVariantsItemId];
  name: string;
  price: ListProjectAddonsResponseAvailableAddonsItemVariantsItemPrice;
  /** Any JSON-serializable value */
  meta?: unknown;
};

export type ListProjectAddonsResponseAvailableAddonsItem = {
  type: ListProjectAddonsResponseAvailableAddonsItemType;
  name: string;
  variants: ListProjectAddonsResponseAvailableAddonsItemVariantsItem[];
};

export interface ListProjectAddonsResponse {
  selected_addons: ListProjectAddonsResponseSelectedAddonsItem[];
  available_addons: ListProjectAddonsResponseAvailableAddonsItem[];
}

export const ApplyProjectAddonBodyAddonVariant = {  ci_micro: 'ci_micro',
  ci_small: 'ci_small',
  ci_medium: 'ci_medium',
  ci_large: 'ci_large',
  ci_xlarge: 'ci_xlarge',
  ci_2xlarge: 'ci_2xlarge',
  ci_4xlarge: 'ci_4xlarge',
  ci_8xlarge: 'ci_8xlarge',
  ci_12xlarge: 'ci_12xlarge',
  ci_16xlarge: 'ci_16xlarge',
  ci_24xlarge: 'ci_24xlarge',
  ci_24xlarge_optimized_cpu: 'ci_24xlarge_optimized_cpu',
  ci_24xlarge_optimized_memory: 'ci_24xlarge_optimized_memory',
  ci_24xlarge_high_memory: 'ci_24xlarge_high_memory',
  ci_48xlarge: 'ci_48xlarge',
  ci_48xlarge_optimized_cpu: 'ci_48xlarge_optimized_cpu',
  ci_48xlarge_optimized_memory: 'ci_48xlarge_optimized_memory',
  ci_48xlarge_high_memory: 'ci_48xlarge_high_memory',
  cd_default: 'cd_default',
  pitr_7: 'pitr_7',
  pitr_14: 'pitr_14',
  pitr_28: 'pitr_28',
  ipv4_default: 'ipv4_default',
} as const
export type ApplyProjectAddonBodyAddonType = typeof ApplyProjectAddonBodyAddonType[keyof typeof ApplyProjectAddonBodyAddonType];


export const ApplyProjectAddonBodyAddonType = {
  custom_domain: 'custom_domain',
  compute_instance: 'compute_instance',
  pitr: 'pitr',
  ipv4: 'ipv4',
  auth_mfa_phone: 'auth_mfa_phone',
  auth_mfa_web_authn: 'auth_mfa_web_authn',
  log_drain: 'log_drain',
} as const;

export interface ApplyProjectAddonBody {
  addon_variant: typeof ApplyProjectAddonBodyAddonVariant[keyof typeof ApplyProjectAddonBodyAddonVariant];
  addon_type: ApplyProjectAddonBodyAddonType;
}

export interface ProjectClaimTokenResponse {
  token_alias: string;
  expires_at: string;
  created_at: string;
  created_by: string;
}

export interface CreateProjectClaimTokenResponse {
  token: string;
  token_alias: string;
  expires_at: string;
  created_at: string;
  created_by: string;
}

export type V1ProjectAdvisorsResponseLintsItemName = typeof V1ProjectAdvisorsResponseLintsItemName[keyof typeof V1ProjectAdvisorsResponseLintsItemName];


export const V1ProjectAdvisorsResponseLintsItemName = {
  unindexed_foreign_keys: 'unindexed_foreign_keys',
  auth_users_exposed: 'auth_users_exposed',
  auth_rls_initplan: 'auth_rls_initplan',
  no_primary_key: 'no_primary_key',
  unused_index: 'unused_index',
  multiple_permissive_policies: 'multiple_permissive_policies',
  policy_exists_rls_disabled: 'policy_exists_rls_disabled',
  rls_enabled_no_policy: 'rls_enabled_no_policy',
  duplicate_index: 'duplicate_index',
  security_definer_view: 'security_definer_view',
  function_search_path_mutable: 'function_search_path_mutable',
  rls_disabled_in_public: 'rls_disabled_in_public',
  extension_in_public: 'extension_in_public',
  rls_references_user_metadata: 'rls_references_user_metadata',
  materialized_view_in_api: 'materialized_view_in_api',
  foreign_table_in_api: 'foreign_table_in_api',
  unsupported_reg_types: 'unsupported_reg_types',
  auth_otp_long_expiry: 'auth_otp_long_expiry',
  auth_otp_short_length: 'auth_otp_short_length',
  ssl_not_enforced: 'ssl_not_enforced',
  network_restrictions_not_set: 'network_restrictions_not_set',
  password_requirements_min_length: 'password_requirements_min_length',
  pitr_not_enabled: 'pitr_not_enabled',
  auth_leaked_password_protection: 'auth_leaked_password_protection',
  auth_insufficient_mfa_options: 'auth_insufficient_mfa_options',
  auth_password_policy_missing: 'auth_password_policy_missing',
  leaked_service_key: 'leaked_service_key',
  no_backup_admin: 'no_backup_admin',
  vulnerable_postgres_version: 'vulnerable_postgres_version',
} as const;

export type V1ProjectAdvisorsResponseLintsItemLevel = typeof V1ProjectAdvisorsResponseLintsItemLevel[keyof typeof V1ProjectAdvisorsResponseLintsItemLevel];


export const V1ProjectAdvisorsResponseLintsItemLevel = {
  ERROR: 'ERROR',
  WARN: 'WARN',
  INFO: 'INFO',
} as const;

export type V1ProjectAdvisorsResponseLintsItemFacing = typeof V1ProjectAdvisorsResponseLintsItemFacing[keyof typeof V1ProjectAdvisorsResponseLintsItemFacing];


export const V1ProjectAdvisorsResponseLintsItemFacing = {
  EXTERNAL: 'EXTERNAL',
} as const;

export type V1ProjectAdvisorsResponseLintsItemCategoriesItem = typeof V1ProjectAdvisorsResponseLintsItemCategoriesItem[keyof typeof V1ProjectAdvisorsResponseLintsItemCategoriesItem];


export const V1ProjectAdvisorsResponseLintsItemCategoriesItem = {
  PERFORMANCE: 'PERFORMANCE',
  SECURITY: 'SECURITY',
} as const;

export type V1ProjectAdvisorsResponseLintsItemMetadataType = typeof V1ProjectAdvisorsResponseLintsItemMetadataType[keyof typeof V1ProjectAdvisorsResponseLintsItemMetadataType];


export const V1ProjectAdvisorsResponseLintsItemMetadataType = {
  table: 'table',
  view: 'view',
  auth: 'auth',
  function: 'function',
  extension: 'extension',
  compliance: 'compliance',
} as const;

export type V1ProjectAdvisorsResponseLintsItemMetadata = {
  schema?: string;
  name?: string;
  entity?: string;
  type?: V1ProjectAdvisorsResponseLintsItemMetadataType;
  fkey_name?: string;
  fkey_columns?: number[];
};

export type V1ProjectAdvisorsResponseLintsItem = {
  name: V1ProjectAdvisorsResponseLintsItemName;
  title: string;
  level: V1ProjectAdvisorsResponseLintsItemLevel;
  facing: V1ProjectAdvisorsResponseLintsItemFacing;
  categories: V1ProjectAdvisorsResponseLintsItemCategoriesItem[];
  description: string;
  detail: string;
  remediation: string;
  metadata?: V1ProjectAdvisorsResponseLintsItemMetadata;
  cache_key: string;
};

export interface V1ProjectAdvisorsResponse {
  lints: V1ProjectAdvisorsResponseLintsItem[];
}

export type AnalyticsResponseError = string | {
  code: number;
  errors: {
  domain: string;
  location: string;
  locationType: string;
  message: string;
  reason: string;
}[];
  message: string;
  status: string;
};

export interface AnalyticsResponse {
  result?: unknown[];
  error?: AnalyticsResponseError;
}

export type V1GetUsageApiCountResponseResultItem = {
  timestamp: string;
  total_auth_requests: number;
  total_realtime_requests: number;
  total_rest_requests: number;
  total_storage_requests: number;
};

export type V1GetUsageApiCountResponseError = string | {
  code: number;
  errors: {
  domain: string;
  location: string;
  locationType: string;
  message: string;
  reason: string;
}[];
  message: string;
  status: string;
};

export interface V1GetUsageApiCountResponse {
  result?: V1GetUsageApiCountResponseResultItem[];
  error?: V1GetUsageApiCountResponseError;
}

export type V1GetUsageApiRequestsCountResponseResultItem = {
  count: number;
};

export type V1GetUsageApiRequestsCountResponseError = string | {
  code: number;
  errors: {
  domain: string;
  location: string;
  locationType: string;
  message: string;
  reason: string;
}[];
  message: string;
  status: string;
};

export interface V1GetUsageApiRequestsCountResponse {
  result?: V1GetUsageApiRequestsCountResponseResultItem[];
  error?: V1GetUsageApiRequestsCountResponseError;
}

export interface CreateRoleBody {
  read_only: boolean;
}

export interface CreateRoleResponse {
  /** @minLength 1 */
  role: string;
  /** @minLength 1 */
  password: string;
  /** @minimum 1 */
  ttl_seconds: number;
}

export type DeleteRolesResponseMessage = typeof DeleteRolesResponseMessage[keyof typeof DeleteRolesResponseMessage];


export const DeleteRolesResponseMessage = {
  ok: 'ok',
} as const;

export interface DeleteRolesResponse {
  message: DeleteRolesResponseMessage;
}

export type V1ListMigrationsResponseItem = {
  /** @minLength 1 */
  version: string;
  name?: string;
};

export type V1ListMigrationsResponse = V1ListMigrationsResponseItem[];

export interface V1CreateMigrationBody {
  /** @minLength 1 */
  query: string;
  name?: string;
  rollback?: string;
}

export interface V1UpsertMigrationBody {
  /** @minLength 1 */
  query: string;
  name?: string;
  rollback?: string;
}

export interface V1GetMigrationResponse {
  /** @minLength 1 */
  version: string;
  name?: string;
  statements?: string[];
  rollback?: string[];
  created_by?: string;
  idempotency_key?: string;
}

export interface V1PatchMigrationBody {
  name?: string;
  rollback?: string;
}

export interface V1RunQueryBody {
  /** @minLength 1 */
  query: string;
  parameters?: unknown[];
  read_only?: boolean;
}

export interface V1ReadOnlyQueryBody {
  /** @minLength 1 */
  query: string;
  parameters?: unknown[];
}

export type GetProjectDbMetadataResponseDatabasesItemSchemasItem = {
  name: string;
  [key: string]: unknown;
 };

export type GetProjectDbMetadataResponseDatabasesItem = {
  name: string;
  schemas: GetProjectDbMetadataResponseDatabasesItemSchemasItem[];
  [key: string]: unknown;
 };

export interface GetProjectDbMetadataResponse {
  databases: GetProjectDbMetadataResponseDatabasesItem[];
}

export interface V1UpdatePasswordBody {
  /** @minLength 4 */
  password: string;
}

export interface V1UpdatePasswordResponse {
  message: string;
}

export interface AuthorizeJitAccessBody {
  /** @minLength 1 */
  role: string;
  /** @minLength 1 */
  rhost: string;
}

export type JitAuthorizeAccessResponseUserRoleAllowedNetworksAllowedCidrsItem = {
  cidr: string;
};

export type JitAuthorizeAccessResponseUserRoleAllowedNetworksAllowedCidrsV6Item = {
  cidr: string;
};

export type JitAuthorizeAccessResponseUserRoleAllowedNetworks = {
  allowed_cidrs?: JitAuthorizeAccessResponseUserRoleAllowedNetworksAllowedCidrsItem[];
  allowed_cidrs_v6?: JitAuthorizeAccessResponseUserRoleAllowedNetworksAllowedCidrsV6Item[];
};

export type JitAuthorizeAccessResponseUserRole = {
  /** @minLength 1 */
  role: string;
  expires_at?: number;
  allowed_networks?: JitAuthorizeAccessResponseUserRoleAllowedNetworks;
};

export interface JitAuthorizeAccessResponse {
  user_id: string;
  user_role: JitAuthorizeAccessResponseUserRole;
}

export type JitListAccessResponseItemsItemUserRolesItemAllowedNetworksAllowedCidrsItem = {
  cidr: string;
};

export type JitListAccessResponseItemsItemUserRolesItemAllowedNetworksAllowedCidrsV6Item = {
  cidr: string;
};

export type JitListAccessResponseItemsItemUserRolesItemAllowedNetworks = {
  allowed_cidrs?: JitListAccessResponseItemsItemUserRolesItemAllowedNetworksAllowedCidrsItem[];
  allowed_cidrs_v6?: JitListAccessResponseItemsItemUserRolesItemAllowedNetworksAllowedCidrsV6Item[];
};

export type JitListAccessResponseItemsItemUserRolesItem = {
  /** @minLength 1 */
  role: string;
  expires_at?: number;
  allowed_networks?: JitListAccessResponseItemsItemUserRolesItemAllowedNetworks;
};

export type JitListAccessResponseItemsItem = {
  user_id: string;
  user_roles: JitListAccessResponseItemsItemUserRolesItem[];
};

export interface JitListAccessResponse {
  items: JitListAccessResponseItemsItem[];
}

export type UpdateJitAccessBodyRolesItemAllowedNetworksAllowedCidrsItem = {
  cidr: string;
};

export type UpdateJitAccessBodyRolesItemAllowedNetworksAllowedCidrsV6Item = {
  cidr: string;
};

export type UpdateJitAccessBodyRolesItemAllowedNetworks = {
  allowed_cidrs?: UpdateJitAccessBodyRolesItemAllowedNetworksAllowedCidrsItem[];
  allowed_cidrs_v6?: UpdateJitAccessBodyRolesItemAllowedNetworksAllowedCidrsV6Item[];
};

export type UpdateJitAccessBodyRolesItem = {
  /** @minLength 1 */
  role: string;
  expires_at?: number;
  allowed_networks?: UpdateJitAccessBodyRolesItemAllowedNetworks;
};

export interface UpdateJitAccessBody {
  /** @minLength 1 */
  user_id: string;
  roles: UpdateJitAccessBodyRolesItem[];
}

export type FunctionResponseStatus = typeof FunctionResponseStatus[keyof typeof FunctionResponseStatus];


export const FunctionResponseStatus = {
  ACTIVE: 'ACTIVE',
  REMOVED: 'REMOVED',
  THROTTLED: 'THROTTLED',
} as const;

export interface FunctionResponse {
  id: string;
  slug: string;
  name: string;
  status: FunctionResponseStatus;
  version: number;
  created_at: number;
  updated_at: number;
  verify_jwt?: boolean;
  import_map?: boolean;
  entrypoint_path?: string;
  import_map_path?: string;
  ezbr_sha256?: string;
}

export interface V1CreateFunctionBody {
  /** @pattern ^[A-Za-z][A-Za-z0-9_-]*$ */
  slug: string;
  name: string;
  body: string;
  verify_jwt?: boolean;
}

export type BulkUpdateFunctionBodyItemStatus = typeof BulkUpdateFunctionBodyItemStatus[keyof typeof BulkUpdateFunctionBodyItemStatus];


export const BulkUpdateFunctionBodyItemStatus = {
  ACTIVE: 'ACTIVE',
  REMOVED: 'REMOVED',
  THROTTLED: 'THROTTLED',
} as const;

export type BulkUpdateFunctionBodyItem = {
  id: string;
  /** @pattern ^[A-Za-z][A-Za-z0-9_-]*$ */
  slug: string;
  name: string;
  status: BulkUpdateFunctionBodyItemStatus;
  version: number;
  created_at?: number;
  verify_jwt?: boolean;
  import_map?: boolean;
  entrypoint_path?: string;
  import_map_path?: string;
  ezbr_sha256?: string;
};

export type BulkUpdateFunctionBody = BulkUpdateFunctionBodyItem[];

export type BulkUpdateFunctionResponseFunctionsItemStatus = typeof BulkUpdateFunctionResponseFunctionsItemStatus[keyof typeof BulkUpdateFunctionResponseFunctionsItemStatus];


export const BulkUpdateFunctionResponseFunctionsItemStatus = {
  ACTIVE: 'ACTIVE',
  REMOVED: 'REMOVED',
  THROTTLED: 'THROTTLED',
} as const;

export type BulkUpdateFunctionResponseFunctionsItem = {
  id: string;
  slug: string;
  name: string;
  status: BulkUpdateFunctionResponseFunctionsItemStatus;
  version: number;
  created_at: number;
  updated_at: number;
  verify_jwt?: boolean;
  import_map?: boolean;
  entrypoint_path?: string;
  import_map_path?: string;
  ezbr_sha256?: string;
};

export interface BulkUpdateFunctionResponse {
  functions: BulkUpdateFunctionResponseFunctionsItem[];
}

export type FunctionDeployBodyMetadata = {
  entrypoint_path: string;
  import_map_path?: string;
  static_patterns?: string[];
  verify_jwt?: boolean;
  name?: string;
};

export interface FunctionDeployBody {
  file?: string[];
  metadata: FunctionDeployBodyMetadata;
}

export type DeployFunctionResponseStatus = typeof DeployFunctionResponseStatus[keyof typeof DeployFunctionResponseStatus];


export const DeployFunctionResponseStatus = {
  ACTIVE: 'ACTIVE',
  REMOVED: 'REMOVED',
  THROTTLED: 'THROTTLED',
} as const;

export interface DeployFunctionResponse {
  id: string;
  slug: string;
  name: string;
  status: DeployFunctionResponseStatus;
  version: number;
  created_at?: number;
  updated_at?: number;
  verify_jwt?: boolean;
  import_map?: boolean;
  entrypoint_path?: string;
  import_map_path?: string;
  ezbr_sha256?: string;
}

export type FunctionSlugResponseStatus = typeof FunctionSlugResponseStatus[keyof typeof FunctionSlugResponseStatus];


export const FunctionSlugResponseStatus = {
  ACTIVE: 'ACTIVE',
  REMOVED: 'REMOVED',
  THROTTLED: 'THROTTLED',
} as const;

export interface FunctionSlugResponse {
  id: string;
  slug: string;
  name: string;
  status: FunctionSlugResponseStatus;
  version: number;
  created_at: number;
  updated_at: number;
  verify_jwt?: boolean;
  import_map?: boolean;
  entrypoint_path?: string;
  import_map_path?: string;
  ezbr_sha256?: string;
}

export interface StreamableFile { [key: string]: unknown }

export interface V1UpdateFunctionBody {
  name?: string;
  body?: string;
  verify_jwt?: boolean;
}

export interface V1StorageBucketResponse {
  id: string;
  name: string;
  owner: string;
  created_at: string;
  updated_at: string;
  public: boolean;
}

export type DiskUtilMetricsResponseMetrics = {
  fs_size_bytes: number;
  fs_avail_bytes: number;
  fs_used_bytes: number;
};

export interface DiskUtilMetricsResponse {
  timestamp: string;
  metrics: DiskUtilMetricsResponseMetrics;
}

export type DiskRequestBodyAttributes = {
  /** @exclusiveMinimum 0 */
  iops: number;
  /** @exclusiveMinimum 0 */
  size_gb: number;
  /** @exclusiveMinimum 0 */
  throughput_mibps?: number;
  type: 'gp3';
} | {
  /** @exclusiveMinimum 0 */
  iops: number;
  /** @exclusiveMinimum 0 */
  size_gb: number;
  type: 'io2';
};

export interface DiskRequestBody {
  attributes: DiskRequestBodyAttributes;
}

export interface DiskAutoscaleConfig {
  /**
   * Growth percentage for disk autoscaling
   * @exclusiveMinimum 0
   * @nullable
   */
  growth_percent: number | null;
  /**
   * Minimum increment size for disk autoscaling in GB
   * @exclusiveMinimum 0
   * @nullable
   */
  min_increment_gb: number | null;
  /**
   * Maximum limit the disk size will grow to in GB
   * @exclusiveMinimum 0
   * @nullable
   */
  max_size_gb: number | null;
}

export type StorageConfigResponseFeaturesImageTransformation = {
  enabled: boolean;
};

export type StorageConfigResponseFeaturesS3Protocol = {
  enabled: boolean;
};

export type StorageConfigResponseFeaturesIcebergCatalog = {
  enabled: boolean;
  /** @minimum 0 */
  maxNamespaces: number;
  /** @minimum 0 */
  maxTables: number;
  /** @minimum 0 */
  maxCatalogs: number;
};

export type StorageConfigResponseFeaturesVectorBuckets = {
  enabled: boolean;
  /** @minimum 0 */
  maxBuckets: number;
  /** @minimum 0 */
  maxIndexes: number;
};

export type StorageConfigResponseFeatures = {
  imageTransformation: StorageConfigResponseFeaturesImageTransformation;
  s3Protocol: StorageConfigResponseFeaturesS3Protocol;
  icebergCatalog: StorageConfigResponseFeaturesIcebergCatalog;
  vectorBuckets: StorageConfigResponseFeaturesVectorBuckets;
};

export type StorageConfigResponseCapabilities = {
  list_v2: boolean;
  iceberg_catalog: boolean;
};

export type StorageConfigResponseExternalUpstreamTarget = typeof StorageConfigResponseExternalUpstreamTarget[keyof typeof StorageConfigResponseExternalUpstreamTarget];


export const StorageConfigResponseExternalUpstreamTarget = {
  main: 'main',
  canary: 'canary',
} as const;

export type StorageConfigResponseExternal = {
  upstreamTarget: StorageConfigResponseExternalUpstreamTarget;
};

export interface StorageConfigResponse {
  fileSizeLimit: number;
  features: StorageConfigResponseFeatures;
  capabilities: StorageConfigResponseCapabilities;
  external: StorageConfigResponseExternal;
  migrationVersion: string;
  databasePoolMode: string;
}

export type UpdateStorageConfigBodyFeaturesImageTransformation = {
  enabled: boolean;
};

export type UpdateStorageConfigBodyFeaturesS3Protocol = {
  enabled: boolean;
};

export type UpdateStorageConfigBodyFeaturesIcebergCatalog = {
  enabled: boolean;
  /** @minimum 0 */
  maxNamespaces: number;
  /** @minimum 0 */
  maxTables: number;
  /** @minimum 0 */
  maxCatalogs: number;
};

export type UpdateStorageConfigBodyFeaturesVectorBuckets = {
  enabled: boolean;
  /** @minimum 0 */
  maxBuckets: number;
  /** @minimum 0 */
  maxIndexes: number;
};

export type UpdateStorageConfigBodyFeatures = {
  imageTransformation?: UpdateStorageConfigBodyFeaturesImageTransformation;
  s3Protocol?: UpdateStorageConfigBodyFeaturesS3Protocol;
  icebergCatalog?: UpdateStorageConfigBodyFeaturesIcebergCatalog;
  vectorBuckets?: UpdateStorageConfigBodyFeaturesVectorBuckets;
};

export type UpdateStorageConfigBodyExternalUpstreamTarget = typeof UpdateStorageConfigBodyExternalUpstreamTarget[keyof typeof UpdateStorageConfigBodyExternalUpstreamTarget];


export const UpdateStorageConfigBodyExternalUpstreamTarget = {
  main: 'main',
  canary: 'canary',
} as const;

export type UpdateStorageConfigBodyExternal = {
  upstreamTarget: UpdateStorageConfigBodyExternalUpstreamTarget;
};

export interface UpdateStorageConfigBody {
  /**
   * @minimum 0
   * @maximum 536870912000
   */
  fileSizeLimit?: number;
  features?: UpdateStorageConfigBodyFeatures;
  external?: UpdateStorageConfigBodyExternal;
}

export type V1PgbouncerConfigResponsePoolMode = typeof V1PgbouncerConfigResponsePoolMode[keyof typeof V1PgbouncerConfigResponsePoolMode];


export const V1PgbouncerConfigResponsePoolMode = {
  transaction: 'transaction',
  session: 'session',
  statement: 'statement',
} as const;

export interface V1PgbouncerConfigResponse {
  default_pool_size?: number;
  ignore_startup_parameters?: string;
  max_client_conn?: number;
  pool_mode?: V1PgbouncerConfigResponsePoolMode;
  connection_string?: string;
  server_idle_timeout?: number;
  server_lifetime?: number;
  query_wait_timeout?: number;
  reserve_pool_size?: number;
}

export type SupavisorConfigResponseDatabaseType = typeof SupavisorConfigResponseDatabaseType[keyof typeof SupavisorConfigResponseDatabaseType];


export const SupavisorConfigResponseDatabaseType = {
  PRIMARY: 'PRIMARY',
  READ_REPLICA: 'READ_REPLICA',
} as const;

export type SupavisorConfigResponsePoolMode = typeof SupavisorConfigResponsePoolMode[keyof typeof SupavisorConfigResponsePoolMode];


export const SupavisorConfigResponsePoolMode = {
  transaction: 'transaction',
  session: 'session',
} as const;

export interface SupavisorConfigResponse {
  identifier: string;
  database_type: SupavisorConfigResponseDatabaseType;
  is_using_scram_auth: boolean;
  db_user: string;
  db_host: string;
  db_port: number;
  db_name: string;
  connection_string: string;
  /** Use connection_string instead */
  connectionString: string;
  /** @nullable */
  default_pool_size: number | null;
  /** @nullable */
  max_client_conn: number | null;
  pool_mode: SupavisorConfigResponsePoolMode;
}

/**
 * Dedicated pooler mode for the project
 */
export type UpdateSupavisorConfigBodyPoolMode = typeof UpdateSupavisorConfigBodyPoolMode[keyof typeof UpdateSupavisorConfigBodyPoolMode];


export const UpdateSupavisorConfigBodyPoolMode = {
  transaction: 'transaction',
  session: 'session',
} as const;

export interface UpdateSupavisorConfigBody {
  /**
   * @minimum 0
   * @maximum 3000
   * @nullable
   */
  default_pool_size?: number | null;
  /** Dedicated pooler mode for the project */
  pool_mode?: UpdateSupavisorConfigBodyPoolMode;
}

export interface UpdateSupavisorConfigResponse {
  /** @nullable */
  default_pool_size: number | null;
  pool_mode: string;
}

export type PostgresConfigResponseSessionReplicationRole = typeof PostgresConfigResponseSessionReplicationRole[keyof typeof PostgresConfigResponseSessionReplicationRole];


export const PostgresConfigResponseSessionReplicationRole = {
  origin: 'origin',
  replica: 'replica',
  local: 'local',
} as const;

export interface PostgresConfigResponse {
  effective_cache_size?: string;
  logical_decoding_work_mem?: string;
  maintenance_work_mem?: string;
  track_activity_query_size?: string;
  /**
   * @minimum 1
   * @maximum 262143
   */
  max_connections?: number;
  /**
   * @minimum 10
   * @maximum 2147483640
   */
  max_locks_per_transaction?: number;
  /**
   * @minimum 0
   * @maximum 1024
   */
  max_parallel_maintenance_workers?: number;
  /**
   * @minimum 0
   * @maximum 1024
   */
  max_parallel_workers?: number;
  /**
   * @minimum 0
   * @maximum 1024
   */
  max_parallel_workers_per_gather?: number;
  max_replication_slots?: number;
  max_slot_wal_keep_size?: string;
  max_standby_archive_delay?: string;
  max_standby_streaming_delay?: string;
  max_wal_size?: string;
  max_wal_senders?: number;
  /**
   * @minimum 0
   * @maximum 262143
   */
  max_worker_processes?: number;
  session_replication_role?: PostgresConfigResponseSessionReplicationRole;
  shared_buffers?: string;
  /**
   * Default unit: ms
   * @pattern ^(-?[0-9]+(?:\.[0-9]+)?)(us|ms|s|min|h|d)?$
   */
  statement_timeout?: string;
  track_commit_timestamp?: boolean;
  wal_keep_size?: string;
  /**
   * Default unit: ms
   * @pattern ^(-?[0-9]+(?:\.[0-9]+)?)(us|ms|s|min|h|d)?$
   */
  wal_sender_timeout?: string;
  work_mem?: string;
  /**
   * Default unit: s
   * @pattern ^(-?[0-9]+(?:\.[0-9]+)?)(us|ms|s|min|h|d)?$
   */
  checkpoint_timeout?: string;
  hot_standby_feedback?: boolean;
}

export type UpdatePostgresConfigBodySessionReplicationRole = typeof UpdatePostgresConfigBodySessionReplicationRole[keyof typeof UpdatePostgresConfigBodySessionReplicationRole];


export const UpdatePostgresConfigBodySessionReplicationRole = {
  origin: 'origin',
  replica: 'replica',
  local: 'local',
} as const;

export interface UpdatePostgresConfigBody {
  effective_cache_size?: string;
  logical_decoding_work_mem?: string;
  maintenance_work_mem?: string;
  track_activity_query_size?: string;
  /**
   * @minimum 1
   * @maximum 262143
   */
  max_connections?: number;
  /**
   * @minimum 10
   * @maximum 2147483640
   */
  max_locks_per_transaction?: number;
  /**
   * @minimum 0
   * @maximum 1024
   */
  max_parallel_maintenance_workers?: number;
  /**
   * @minimum 0
   * @maximum 1024
   */
  max_parallel_workers?: number;
  /**
   * @minimum 0
   * @maximum 1024
   */
  max_parallel_workers_per_gather?: number;
  max_replication_slots?: number;
  max_slot_wal_keep_size?: string;
  max_standby_archive_delay?: string;
  max_standby_streaming_delay?: string;
  max_wal_size?: string;
  max_wal_senders?: number;
  /**
   * @minimum 0
   * @maximum 262143
   */
  max_worker_processes?: number;
  session_replication_role?: UpdatePostgresConfigBodySessionReplicationRole;
  shared_buffers?: string;
  /**
   * Default unit: ms
   * @pattern ^(-?[0-9]+(?:\.[0-9]+)?)(us|ms|s|min|h|d)?$
   */
  statement_timeout?: string;
  track_commit_timestamp?: boolean;
  wal_keep_size?: string;
  /**
   * Default unit: ms
   * @pattern ^(-?[0-9]+(?:\.[0-9]+)?)(us|ms|s|min|h|d)?$
   */
  wal_sender_timeout?: string;
  work_mem?: string;
  /**
   * Default unit: s
   * @pattern ^(-?[0-9]+(?:\.[0-9]+)?)(us|ms|s|min|h|d)?$
   */
  checkpoint_timeout?: string;
  hot_standby_feedback?: boolean;
  restart_database?: boolean;
}

export interface RealtimeConfigResponse {
  /**
   * Whether to only allow private channels
   * @nullable
   */
  private_only: boolean | null;
  /**
   * Sets connection pool size for Realtime Authorization
   * @minimum 1
   * @maximum 100
   * @nullable
   */
  connection_pool: number | null;
  /**
   * Sets maximum number of concurrent users rate limit
   * @minimum 1
   * @maximum 50000
   * @nullable
   */
  max_concurrent_users: number | null;
  /**
   * Sets maximum number of events per second rate per channel limit
   * @minimum 1
   * @maximum 50000
   * @nullable
   */
  max_events_per_second: number | null;
  /**
   * Sets maximum number of bytes per second rate per channel limit
   * @minimum 1
   * @maximum 10000000
   * @nullable
   */
  max_bytes_per_second: number | null;
  /**
   * Sets maximum number of channels per client rate limit
   * @minimum 1
   * @maximum 10000
   * @nullable
   */
  max_channels_per_client: number | null;
  /**
   * Sets maximum number of joins per second rate limit
   * @minimum 1
   * @maximum 5000
   * @nullable
   */
  max_joins_per_second: number | null;
  /**
   * Sets maximum number of presence events per second rate limit
   * @minimum 1
   * @maximum 5000
   * @nullable
   */
  max_presence_events_per_second: number | null;
  /**
   * Sets maximum number of payload size in KB rate limit
   * @minimum 1
   * @maximum 10000
   * @nullable
   */
  max_payload_size_in_kb: number | null;
  /**
   * Whether to suspend realtime
   * @nullable
   */
  suspend: boolean | null;
}

export interface UpdateRealtimeConfigBody {
  /** Whether to only allow private channels */
  private_only?: boolean;
  /**
   * Sets connection pool size for Realtime Authorization
   * @minimum 1
   * @maximum 100
   */
  connection_pool?: number;
  /**
   * Sets maximum number of concurrent users rate limit
   * @minimum 1
   * @maximum 50000
   */
  max_concurrent_users?: number;
  /**
   * Sets maximum number of events per second rate per channel limit
   * @minimum 1
   * @maximum 50000
   */
  max_events_per_second?: number;
  /**
   * Sets maximum number of bytes per second rate per channel limit
   * @minimum 1
   * @maximum 10000000
   */
  max_bytes_per_second?: number;
  /**
   * Sets maximum number of channels per client rate limit
   * @minimum 1
   * @maximum 10000
   */
  max_channels_per_client?: number;
  /**
   * Sets maximum number of joins per second rate limit
   * @minimum 1
   * @maximum 5000
   */
  max_joins_per_second?: number;
  /**
   * Sets maximum number of presence events per second rate limit
   * @minimum 1
   * @maximum 5000
   */
  max_presence_events_per_second?: number;
  /**
   * Sets maximum number of payload size in KB rate limit
   * @minimum 1
   * @maximum 10000
   */
  max_payload_size_in_kb?: number;
  /** Whether to suspend realtime */
  suspend?: boolean;
}

/**
 * What type of provider will be created
 */
export type CreateProviderBodyType = typeof CreateProviderBodyType[keyof typeof CreateProviderBodyType];


export const CreateProviderBodyType = {
  saml: 'saml',
} as const;

export type CreateProviderBodyAttributeMappingKeysDefault = { [key: string]: unknown } | number | string | boolean;

export type CreateProviderBodyAttributeMappingKeys = {[key: string]: {
  name?: string;
  names?: string[];
  default?: CreateProviderBodyAttributeMappingKeysDefault;
  array?: boolean;
}};

export type CreateProviderBodyAttributeMapping = {
  keys: CreateProviderBodyAttributeMappingKeys;
};

export type CreateProviderBodyNameIdFormat = typeof CreateProviderBodyNameIdFormat[keyof typeof CreateProviderBodyNameIdFormat];


export const CreateProviderBodyNameIdFormat = {
  'urn:oasis:names:tc:SAML:11:nameid-format:unspecified': 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
  'urn:oasis:names:tc:SAML:20:nameid-format:transient': 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
  'urn:oasis:names:tc:SAML:11:nameid-format:emailAddress': 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  'urn:oasis:names:tc:SAML:20:nameid-format:persistent': 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
} as const;

export interface CreateProviderBody {
  /** What type of provider will be created */
  type: CreateProviderBodyType;
  metadata_xml?: string;
  metadata_url?: string;
  domains?: string[];
  attribute_mapping?: CreateProviderBodyAttributeMapping;
  name_id_format?: CreateProviderBodyNameIdFormat;
}

export type CreateProviderResponseSamlAttributeMappingKeysDefault = { [key: string]: unknown } | number | string | boolean;

export type CreateProviderResponseSamlAttributeMappingKeys = {[key: string]: {
  name?: string;
  names?: string[];
  default?: CreateProviderResponseSamlAttributeMappingKeysDefault;
  array?: boolean;
}};

export type CreateProviderResponseSamlAttributeMapping = {
  keys: CreateProviderResponseSamlAttributeMappingKeys;
};

export type CreateProviderResponseSamlNameIdFormat = typeof CreateProviderResponseSamlNameIdFormat[keyof typeof CreateProviderResponseSamlNameIdFormat];


export const CreateProviderResponseSamlNameIdFormat = {
  'urn:oasis:names:tc:SAML:11:nameid-format:unspecified': 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
  'urn:oasis:names:tc:SAML:20:nameid-format:transient': 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
  'urn:oasis:names:tc:SAML:11:nameid-format:emailAddress': 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  'urn:oasis:names:tc:SAML:20:nameid-format:persistent': 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
} as const;

export type CreateProviderResponseSaml = {
  id: string;
  entity_id: string;
  metadata_url?: string;
  metadata_xml?: string;
  attribute_mapping?: CreateProviderResponseSamlAttributeMapping;
  name_id_format?: CreateProviderResponseSamlNameIdFormat;
};

export type CreateProviderResponseDomainsItem = {
  id: string;
  domain?: string;
  created_at?: string;
  updated_at?: string;
};

export interface CreateProviderResponse {
  id: string;
  saml?: CreateProviderResponseSaml;
  domains?: CreateProviderResponseDomainsItem[];
  created_at?: string;
  updated_at?: string;
}

export type ListProvidersResponseItemsItemSamlAttributeMappingKeysDefault = { [key: string]: unknown } | number | string | boolean;

export type ListProvidersResponseItemsItemSamlAttributeMappingKeys = {[key: string]: {
  name?: string;
  names?: string[];
  default?: ListProvidersResponseItemsItemSamlAttributeMappingKeysDefault;
  array?: boolean;
}};

export type ListProvidersResponseItemsItemSamlAttributeMapping = {
  keys: ListProvidersResponseItemsItemSamlAttributeMappingKeys;
};

export type ListProvidersResponseItemsItemSamlNameIdFormat = typeof ListProvidersResponseItemsItemSamlNameIdFormat[keyof typeof ListProvidersResponseItemsItemSamlNameIdFormat];


export const ListProvidersResponseItemsItemSamlNameIdFormat = {
  'urn:oasis:names:tc:SAML:11:nameid-format:unspecified': 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
  'urn:oasis:names:tc:SAML:20:nameid-format:transient': 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
  'urn:oasis:names:tc:SAML:11:nameid-format:emailAddress': 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  'urn:oasis:names:tc:SAML:20:nameid-format:persistent': 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
} as const;

export type ListProvidersResponseItemsItemSaml = {
  id: string;
  entity_id: string;
  metadata_url?: string;
  metadata_xml?: string;
  attribute_mapping?: ListProvidersResponseItemsItemSamlAttributeMapping;
  name_id_format?: ListProvidersResponseItemsItemSamlNameIdFormat;
};

export type ListProvidersResponseItemsItemDomainsItem = {
  id: string;
  domain?: string;
  created_at?: string;
  updated_at?: string;
};

export type ListProvidersResponseItemsItem = {
  id: string;
  saml?: ListProvidersResponseItemsItemSaml;
  domains?: ListProvidersResponseItemsItemDomainsItem[];
  created_at?: string;
  updated_at?: string;
};

export interface ListProvidersResponse {
  items: ListProvidersResponseItemsItem[];
}

export type GetProviderResponseSamlAttributeMappingKeysDefault = { [key: string]: unknown } | number | string | boolean;

export type GetProviderResponseSamlAttributeMappingKeys = {[key: string]: {
  name?: string;
  names?: string[];
  default?: GetProviderResponseSamlAttributeMappingKeysDefault;
  array?: boolean;
}};

export type GetProviderResponseSamlAttributeMapping = {
  keys: GetProviderResponseSamlAttributeMappingKeys;
};

export type GetProviderResponseSamlNameIdFormat = typeof GetProviderResponseSamlNameIdFormat[keyof typeof GetProviderResponseSamlNameIdFormat];


export const GetProviderResponseSamlNameIdFormat = {
  'urn:oasis:names:tc:SAML:11:nameid-format:unspecified': 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
  'urn:oasis:names:tc:SAML:20:nameid-format:transient': 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
  'urn:oasis:names:tc:SAML:11:nameid-format:emailAddress': 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  'urn:oasis:names:tc:SAML:20:nameid-format:persistent': 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
} as const;

export type GetProviderResponseSaml = {
  id: string;
  entity_id: string;
  metadata_url?: string;
  metadata_xml?: string;
  attribute_mapping?: GetProviderResponseSamlAttributeMapping;
  name_id_format?: GetProviderResponseSamlNameIdFormat;
};

export type GetProviderResponseDomainsItem = {
  id: string;
  domain?: string;
  created_at?: string;
  updated_at?: string;
};

export interface GetProviderResponse {
  id: string;
  saml?: GetProviderResponseSaml;
  domains?: GetProviderResponseDomainsItem[];
  created_at?: string;
  updated_at?: string;
}

export type UpdateProviderBodyAttributeMappingKeysDefault = { [key: string]: unknown } | number | string | boolean;

export type UpdateProviderBodyAttributeMappingKeys = {[key: string]: {
  name?: string;
  names?: string[];
  default?: UpdateProviderBodyAttributeMappingKeysDefault;
  array?: boolean;
}};

export type UpdateProviderBodyAttributeMapping = {
  keys: UpdateProviderBodyAttributeMappingKeys;
};

export type UpdateProviderBodyNameIdFormat = typeof UpdateProviderBodyNameIdFormat[keyof typeof UpdateProviderBodyNameIdFormat];


export const UpdateProviderBodyNameIdFormat = {
  'urn:oasis:names:tc:SAML:11:nameid-format:unspecified': 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
  'urn:oasis:names:tc:SAML:20:nameid-format:transient': 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
  'urn:oasis:names:tc:SAML:11:nameid-format:emailAddress': 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  'urn:oasis:names:tc:SAML:20:nameid-format:persistent': 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
} as const;

export interface UpdateProviderBody {
  metadata_xml?: string;
  metadata_url?: string;
  domains?: string[];
  attribute_mapping?: UpdateProviderBodyAttributeMapping;
  name_id_format?: UpdateProviderBodyNameIdFormat;
}

export type UpdateProviderResponseSamlAttributeMappingKeysDefault = { [key: string]: unknown } | number | string | boolean;

export type UpdateProviderResponseSamlAttributeMappingKeys = {[key: string]: {
  name?: string;
  names?: string[];
  default?: UpdateProviderResponseSamlAttributeMappingKeysDefault;
  array?: boolean;
}};

export type UpdateProviderResponseSamlAttributeMapping = {
  keys: UpdateProviderResponseSamlAttributeMappingKeys;
};

export type UpdateProviderResponseSamlNameIdFormat = typeof UpdateProviderResponseSamlNameIdFormat[keyof typeof UpdateProviderResponseSamlNameIdFormat];


export const UpdateProviderResponseSamlNameIdFormat = {
  'urn:oasis:names:tc:SAML:11:nameid-format:unspecified': 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
  'urn:oasis:names:tc:SAML:20:nameid-format:transient': 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
  'urn:oasis:names:tc:SAML:11:nameid-format:emailAddress': 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  'urn:oasis:names:tc:SAML:20:nameid-format:persistent': 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
} as const;

export type UpdateProviderResponseSaml = {
  id: string;
  entity_id: string;
  metadata_url?: string;
  metadata_xml?: string;
  attribute_mapping?: UpdateProviderResponseSamlAttributeMapping;
  name_id_format?: UpdateProviderResponseSamlNameIdFormat;
};

export type UpdateProviderResponseDomainsItem = {
  id: string;
  domain?: string;
  created_at?: string;
  updated_at?: string;
};

export interface UpdateProviderResponse {
  id: string;
  saml?: UpdateProviderResponseSaml;
  domains?: UpdateProviderResponseDomainsItem[];
  created_at?: string;
  updated_at?: string;
}

export type DeleteProviderResponseSamlAttributeMappingKeysDefault = { [key: string]: unknown } | number | string | boolean;

export type DeleteProviderResponseSamlAttributeMappingKeys = {[key: string]: {
  name?: string;
  names?: string[];
  default?: DeleteProviderResponseSamlAttributeMappingKeysDefault;
  array?: boolean;
}};

export type DeleteProviderResponseSamlAttributeMapping = {
  keys: DeleteProviderResponseSamlAttributeMappingKeys;
};

export type DeleteProviderResponseSamlNameIdFormat = typeof DeleteProviderResponseSamlNameIdFormat[keyof typeof DeleteProviderResponseSamlNameIdFormat];


export const DeleteProviderResponseSamlNameIdFormat = {
  'urn:oasis:names:tc:SAML:11:nameid-format:unspecified': 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
  'urn:oasis:names:tc:SAML:20:nameid-format:transient': 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
  'urn:oasis:names:tc:SAML:11:nameid-format:emailAddress': 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  'urn:oasis:names:tc:SAML:20:nameid-format:persistent': 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
} as const;

export type DeleteProviderResponseSaml = {
  id: string;
  entity_id: string;
  metadata_url?: string;
  metadata_xml?: string;
  attribute_mapping?: DeleteProviderResponseSamlAttributeMapping;
  name_id_format?: DeleteProviderResponseSamlNameIdFormat;
};

export type DeleteProviderResponseDomainsItem = {
  id: string;
  domain?: string;
  created_at?: string;
  updated_at?: string;
};

export interface DeleteProviderResponse {
  id: string;
  saml?: DeleteProviderResponseSaml;
  domains?: DeleteProviderResponseDomainsItem[];
  created_at?: string;
  updated_at?: string;
}

export type V1BackupsResponseBackupsItemStatus = typeof V1BackupsResponseBackupsItemStatus[keyof typeof V1BackupsResponseBackupsItemStatus];


export const V1BackupsResponseBackupsItemStatus = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  REMOVED: 'REMOVED',
  ARCHIVED: 'ARCHIVED',
  CANCELLED: 'CANCELLED',
} as const;

export type V1BackupsResponseBackupsItem = {
  is_physical_backup: boolean;
  status: V1BackupsResponseBackupsItemStatus;
  inserted_at: string;
};

export type V1BackupsResponsePhysicalBackupData = {
  earliest_physical_backup_date_unix?: number;
  latest_physical_backup_date_unix?: number;
};

export interface V1BackupsResponse {
  region: string;
  walg_enabled: boolean;
  pitr_enabled: boolean;
  backups: V1BackupsResponseBackupsItem[];
  physical_backup_data: V1BackupsResponsePhysicalBackupData;
}

export interface V1RestorePitrBody {
  /** @minimum 0 */
  recovery_time_target_unix: number;
}

export interface V1RestorePointPostBody {
  /** @maxLength 20 */
  name: string;
}

export type V1RestorePointResponseStatus = typeof V1RestorePointResponseStatus[keyof typeof V1RestorePointResponseStatus];


export const V1RestorePointResponseStatus = {
  AVAILABLE: 'AVAILABLE',
  PENDING: 'PENDING',
  REMOVED: 'REMOVED',
  FAILED: 'FAILED',
} as const;

export interface V1RestorePointResponse {
  name: string;
  status: V1RestorePointResponseStatus;
}

export interface V1UndoBody {
  /** @maxLength 20 */
  name: string;
}

export interface V1OrganizationMemberResponse {
  user_id: string;
  user_name: string;
  email?: string;
  role_name: string;
  mfa_enabled: boolean;
}

export type V1OrganizationSlugResponsePlan = typeof V1OrganizationSlugResponsePlan[keyof typeof V1OrganizationSlugResponsePlan];


export const V1OrganizationSlugResponsePlan = {
  free: 'free',
  pro: 'pro',
  team: 'team',
  enterprise: 'enterprise',
  platform: 'platform',
} as const;

export type V1OrganizationSlugResponseOptInTagsItem = typeof V1OrganizationSlugResponseOptInTagsItem[keyof typeof V1OrganizationSlugResponseOptInTagsItem];


export const V1OrganizationSlugResponseOptInTagsItem = {
  AI_SQL_GENERATOR_OPT_IN: 'AI_SQL_GENERATOR_OPT_IN',
  AI_DATA_GENERATOR_OPT_IN: 'AI_DATA_GENERATOR_OPT_IN',
  AI_LOG_GENERATOR_OPT_IN: 'AI_LOG_GENERATOR_OPT_IN',
} as const;

export type V1OrganizationSlugResponseAllowedReleaseChannelsItem = typeof V1OrganizationSlugResponseAllowedReleaseChannelsItem[keyof typeof V1OrganizationSlugResponseAllowedReleaseChannelsItem];


export const V1OrganizationSlugResponseAllowedReleaseChannelsItem = {
  internal: 'internal',
  alpha: 'alpha',
  beta: 'beta',
  ga: 'ga',
  withdrawn: 'withdrawn',
  preview: 'preview',
} as const;

export interface V1OrganizationSlugResponse {
  id: string;
  name: string;
  plan?: V1OrganizationSlugResponsePlan;
  opt_in_tags: V1OrganizationSlugResponseOptInTagsItem[];
  allowed_release_channels: V1OrganizationSlugResponseAllowedReleaseChannelsItem[];
}

export type OrganizationProjectClaimResponseProject = {
  ref: string;
  name: string;
};

export type OrganizationProjectClaimResponsePreviewWarningsItem = {
  key: string;
  message: string;
};

export type OrganizationProjectClaimResponsePreviewErrorsItem = {
  key: string;
  message: string;
};

export type OrganizationProjectClaimResponsePreviewInfoItem = {
  key: string;
  message: string;
};

export type OrganizationProjectClaimResponsePreviewMembersExceedingFreeProjectLimitItem = {
  name: string;
  limit: number;
};

export type OrganizationProjectClaimResponsePreviewSourceSubscriptionPlan = typeof OrganizationProjectClaimResponsePreviewSourceSubscriptionPlan[keyof typeof OrganizationProjectClaimResponsePreviewSourceSubscriptionPlan];


export const OrganizationProjectClaimResponsePreviewSourceSubscriptionPlan = {
  free: 'free',
  pro: 'pro',
  team: 'team',
  enterprise: 'enterprise',
  platform: 'platform',
} as const;

/**
 * @nullable
 */
export type OrganizationProjectClaimResponsePreviewTargetSubscriptionPlan = typeof OrganizationProjectClaimResponsePreviewTargetSubscriptionPlan[keyof typeof OrganizationProjectClaimResponsePreviewTargetSubscriptionPlan] | null;


export const OrganizationProjectClaimResponsePreviewTargetSubscriptionPlan = {
  free: 'free',
  pro: 'pro',
  team: 'team',
  enterprise: 'enterprise',
  platform: 'platform',
} as const;

export type OrganizationProjectClaimResponsePreview = {
  valid: boolean;
  warnings: OrganizationProjectClaimResponsePreviewWarningsItem[];
  errors: OrganizationProjectClaimResponsePreviewErrorsItem[];
  info: OrganizationProjectClaimResponsePreviewInfoItem[];
  members_exceeding_free_project_limit: OrganizationProjectClaimResponsePreviewMembersExceedingFreeProjectLimitItem[];
  source_subscription_plan: OrganizationProjectClaimResponsePreviewSourceSubscriptionPlan;
  /** @nullable */
  target_subscription_plan: OrganizationProjectClaimResponsePreviewTargetSubscriptionPlan;
};

export interface OrganizationProjectClaimResponse {
  project: OrganizationProjectClaimResponseProject;
  preview: OrganizationProjectClaimResponsePreview;
  expires_at: string;
  created_at: string;
  created_by: string;
}

export type OrganizationProjectsResponseProjectsItemStatus = typeof OrganizationProjectsResponseProjectsItemStatus[keyof typeof OrganizationProjectsResponseProjectsItemStatus];


export const OrganizationProjectsResponseProjectsItemStatus = {
  INACTIVE: 'INACTIVE',
  ACTIVE_HEALTHY: 'ACTIVE_HEALTHY',
  ACTIVE_UNHEALTHY: 'ACTIVE_UNHEALTHY',
  COMING_UP: 'COMING_UP',
  UNKNOWN: 'UNKNOWN',
  GOING_DOWN: 'GOING_DOWN',
  INIT_FAILED: 'INIT_FAILED',
  REMOVED: 'REMOVED',
  RESTORING: 'RESTORING',
  UPGRADING: 'UPGRADING',
  PAUSING: 'PAUSING',
  RESTORE_FAILED: 'RESTORE_FAILED',
  RESTARTING: 'RESTARTING',
  PAUSE_FAILED: 'PAUSE_FAILED',
  RESIZING: 'RESIZING',
} as const;

export type OrganizationProjectsResponseProjectsItemDatabasesItemInfraComputeSize = typeof OrganizationProjectsResponseProjectsItemDatabasesItemInfraComputeSize[keyof typeof OrganizationProjectsResponseProjectsItemDatabasesItemInfraComputeSize];


export const OrganizationProjectsResponseProjectsItemDatabasesItemInfraComputeSize = {
  pico: 'pico',
  nano: 'nano',
  micro: 'micro',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge',
  '2xlarge': '2xlarge',
  '4xlarge': '4xlarge',
  '8xlarge': '8xlarge',
  '12xlarge': '12xlarge',
  '16xlarge': '16xlarge',
  '24xlarge': '24xlarge',
  '24xlarge_optimized_memory': '24xlarge_optimized_memory',
  '24xlarge_optimized_cpu': '24xlarge_optimized_cpu',
  '24xlarge_high_memory': '24xlarge_high_memory',
  '48xlarge': '48xlarge',
  '48xlarge_optimized_memory': '48xlarge_optimized_memory',
  '48xlarge_optimized_cpu': '48xlarge_optimized_cpu',
  '48xlarge_high_memory': '48xlarge_high_memory',
} as const;

export type OrganizationProjectsResponseProjectsItemDatabasesItemStatus = typeof OrganizationProjectsResponseProjectsItemDatabasesItemStatus[keyof typeof OrganizationProjectsResponseProjectsItemDatabasesItemStatus];


export const OrganizationProjectsResponseProjectsItemDatabasesItemStatus = {
  ACTIVE_HEALTHY: 'ACTIVE_HEALTHY',
  ACTIVE_UNHEALTHY: 'ACTIVE_UNHEALTHY',
  COMING_UP: 'COMING_UP',
  GOING_DOWN: 'GOING_DOWN',
  INIT_FAILED: 'INIT_FAILED',
  REMOVED: 'REMOVED',
  RESTORING: 'RESTORING',
  UNKNOWN: 'UNKNOWN',
  INIT_READ_REPLICA: 'INIT_READ_REPLICA',
  INIT_READ_REPLICA_FAILED: 'INIT_READ_REPLICA_FAILED',
  RESTARTING: 'RESTARTING',
  RESIZING: 'RESIZING',
} as const;

export type OrganizationProjectsResponseProjectsItemDatabasesItemType = typeof OrganizationProjectsResponseProjectsItemDatabasesItemType[keyof typeof OrganizationProjectsResponseProjectsItemDatabasesItemType];


export const OrganizationProjectsResponseProjectsItemDatabasesItemType = {
  PRIMARY: 'PRIMARY',
  READ_REPLICA: 'READ_REPLICA',
} as const;

export type OrganizationProjectsResponseProjectsItemDatabasesItemDiskType = typeof OrganizationProjectsResponseProjectsItemDatabasesItemDiskType[keyof typeof OrganizationProjectsResponseProjectsItemDatabasesItemDiskType];


export const OrganizationProjectsResponseProjectsItemDatabasesItemDiskType = {
  gp3: 'gp3',
  io2: 'io2',
} as const;

export type OrganizationProjectsResponseProjectsItemDatabasesItem = {
  infra_compute_size?: OrganizationProjectsResponseProjectsItemDatabasesItemInfraComputeSize;
  region: string;
  status: OrganizationProjectsResponseProjectsItemDatabasesItemStatus;
  cloud_provider: string;
  identifier: string;
  type: OrganizationProjectsResponseProjectsItemDatabasesItemType;
  disk_volume_size_gb?: number;
  disk_type?: OrganizationProjectsResponseProjectsItemDatabasesItemDiskType;
  disk_throughput_mbps?: number;
  disk_last_modified_at?: string;
};

export type OrganizationProjectsResponseProjectsItem = {
  ref: string;
  name: string;
  cloud_provider: string;
  region: string;
  is_branch: boolean;
  status: OrganizationProjectsResponseProjectsItemStatus;
  inserted_at: string;
  databases: OrganizationProjectsResponseProjectsItemDatabasesItem[];
};

export type OrganizationProjectsResponsePagination = {
  /** Total number of projects. Use this to calculate the total number of pages. */
  count: number;
  /** Maximum number of projects per page */
  limit: number;
  /** Number of projects skipped in this response */
  offset: number;
};

export interface OrganizationProjectsResponse {
  projects: OrganizationProjectsResponseProjectsItem[];
  pagination: OrganizationProjectsResponsePagination;
}

export type V1DeleteABranchParams = {
/**
 * If set to false, schedule deletion with 1-hour grace period (only when soft deletion is enabled).
 */
force?: boolean;
};

export type V1DiffABranchParams = {
included_schemas?: string;
};

export type V1GetAvailableRegionsParams = {
/**
 * Slug of your organization
 */
organization_slug: string;
/**
 * Continent code to determine regional recommendations: NA (North America), SA (South America), EU (Europe), AF (Africa), AS (Asia), OC (Oceania), AN (Antarctica)
 */
continent?: V1GetAvailableRegionsContinent;
/**
 * Desired instance size
 */
desired_instance_size?: V1GetAvailableRegionsDesiredInstanceSize;
};

export type V1GetAvailableRegionsContinent = typeof V1GetAvailableRegionsContinent[keyof typeof V1GetAvailableRegionsContinent];


export const V1GetAvailableRegionsContinent = {
  NA: 'NA',
  SA: 'SA',
  EU: 'EU',
  AF: 'AF',
  AS: 'AS',
  OC: 'OC',
  AN: 'AN',
} as const;

export type V1GetAvailableRegionsDesiredInstanceSize = typeof V1GetAvailableRegionsDesiredInstanceSize[keyof typeof V1GetAvailableRegionsDesiredInstanceSize];


export const V1GetAvailableRegionsDesiredInstanceSize = {
  pico: 'pico',
  nano: 'nano',
  micro: 'micro',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge',
  '2xlarge': '2xlarge',
  '4xlarge': '4xlarge',
  '8xlarge': '8xlarge',
  '12xlarge': '12xlarge',
  '16xlarge': '16xlarge',
  '24xlarge': '24xlarge',
  '24xlarge_optimized_memory': '24xlarge_optimized_memory',
  '24xlarge_optimized_cpu': '24xlarge_optimized_cpu',
  '24xlarge_high_memory': '24xlarge_high_memory',
  '48xlarge': '48xlarge',
  '48xlarge_optimized_memory': '48xlarge_optimized_memory',
  '48xlarge_optimized_cpu': '48xlarge_optimized_cpu',
  '48xlarge_high_memory': '48xlarge_high_memory',
} as const;

export type V1AuthorizeUserParams = {
client_id: string;
response_type: V1AuthorizeUserResponseType;
redirect_uri: string;
scope?: string;
state?: string;
response_mode?: string;
code_challenge?: string;
code_challenge_method?: V1AuthorizeUserCodeChallengeMethod;
/**
 * Organization slug
 * @pattern ^[\w-]+$
 */
organization_slug?: string;
/**
 * Resource indicator for MCP (Model Context Protocol) clients
 */
resource?: string;
};

export type V1AuthorizeUserResponseType = typeof V1AuthorizeUserResponseType[keyof typeof V1AuthorizeUserResponseType];


export const V1AuthorizeUserResponseType = {
  code: 'code',
  token: 'token',
  id_token_token: 'id_token token',
} as const;

export type V1AuthorizeUserCodeChallengeMethod = typeof V1AuthorizeUserCodeChallengeMethod[keyof typeof V1AuthorizeUserCodeChallengeMethod];


export const V1AuthorizeUserCodeChallengeMethod = {
  plain: 'plain',
  sha256: 'sha256',
  S256: 'S256',
} as const;

export type V1OauthAuthorizeProjectClaimParams = {
/**
 * Project ref
 * @minLength 20
 * @maxLength 20
 * @pattern ^[a-z]+$
 */
project_ref: string;
client_id: string;
response_type: V1OauthAuthorizeProjectClaimResponseType;
redirect_uri: string;
state?: string;
response_mode?: string;
code_challenge?: string;
code_challenge_method?: V1OauthAuthorizeProjectClaimCodeChallengeMethod;
};

export type V1OauthAuthorizeProjectClaimResponseType = typeof V1OauthAuthorizeProjectClaimResponseType[keyof typeof V1OauthAuthorizeProjectClaimResponseType];


export const V1OauthAuthorizeProjectClaimResponseType = {
  code: 'code',
  token: 'token',
  id_token_token: 'id_token token',
} as const;

export type V1OauthAuthorizeProjectClaimCodeChallengeMethod = typeof V1OauthAuthorizeProjectClaimCodeChallengeMethod[keyof typeof V1OauthAuthorizeProjectClaimCodeChallengeMethod];


export const V1OauthAuthorizeProjectClaimCodeChallengeMethod = {
  plain: 'plain',
  sha256: 'sha256',
  S256: 'S256',
} as const;

export type V1ListAllSnippetsParams = {
/**
 * Project ref
 * @minLength 20
 * @maxLength 20
 * @pattern ^[a-z]+$
 */
project_ref?: string;
cursor?: string;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: string;
sort_by?: V1ListAllSnippetsSortBy;
sort_order?: V1ListAllSnippetsSortOrder;
};

export type V1ListAllSnippetsSortBy = typeof V1ListAllSnippetsSortBy[keyof typeof V1ListAllSnippetsSortBy];


export const V1ListAllSnippetsSortBy = {
  name: 'name',
  inserted_at: 'inserted_at',
} as const;

export type V1ListAllSnippetsSortOrder = typeof V1ListAllSnippetsSortOrder[keyof typeof V1ListAllSnippetsSortOrder];


export const V1ListAllSnippetsSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type V1ListActionRunsParams = {
/**
 * @minimum 0
 */
offset?: number;
/**
 * @minimum 10
 */
limit?: number;
};

export type V1GetProjectApiKeysParams = {
/**
 * Boolean string, true or false
 */
reveal?: boolean;
};

export type V1CreateProjectApiKeyParams = {
/**
 * Boolean string, true or false
 */
reveal?: boolean;
};

export type V1UpdateProjectLegacyApiKeysParams = {
/**
 * Boolean string, true or false
 */
enabled: boolean;
};

export type V1UpdateProjectApiKeyParams = {
/**
 * Boolean string, true or false
 */
reveal?: boolean;
};

export type V1GetProjectApiKeyParams = {
/**
 * Boolean string, true or false
 */
reveal?: boolean;
};

export type V1DeleteProjectApiKeyParams = {
/**
 * Boolean string, true or false
 */
reveal?: boolean;
/**
 * Boolean string, true or false
 */
was_compromised?: boolean;
reason?: string;
};

export type V1GenerateTypescriptTypesParams = {
included_schemas?: string;
};

export type V1GetPostgresUpgradeStatusParams = {
tracking_id?: string;
};

export type V1GetServicesHealthParams = {
services: V1GetServicesHealthServicesItem[];
/**
 * @minimum 0
 * @maximum 10000
 */
timeout_ms?: number;
};

export type V1GetServicesHealthServicesItem = typeof V1GetServicesHealthServicesItem[keyof typeof V1GetServicesHealthServicesItem];


export const V1GetServicesHealthServicesItem = {
  auth: 'auth',
  db: 'db',
  db_postgres_user: 'db_postgres_user',
  pooler: 'pooler',
  realtime: 'realtime',
  rest: 'rest',
  storage: 'storage',
  pg_bouncer: 'pg_bouncer',
} as const;

export type V1GetSecurityAdvisorsParams = {
lint_type?: V1GetSecurityAdvisorsLintType;
};

export type V1GetSecurityAdvisorsLintType = typeof V1GetSecurityAdvisorsLintType[keyof typeof V1GetSecurityAdvisorsLintType];


export const V1GetSecurityAdvisorsLintType = {
  sql: 'sql',
} as const;

export type V1GetProjectLogsParams = {
/**
 * Custom SQL query to execute on the logs. See [querying logs](/docs/guides/telemetry/logs?queryGroups=product&product=postgres&queryGroups=source&source=edge_logs#querying-with-the-logs-explorer) for more details.
 */
sql?: string;
iso_timestamp_start?: string;
iso_timestamp_end?: string;
};

export type V1GetProjectUsageApiCountParams = {
interval?: V1GetProjectUsageApiCountInterval;
};

export type V1GetProjectUsageApiCountInterval = typeof V1GetProjectUsageApiCountInterval[keyof typeof V1GetProjectUsageApiCountInterval];


export const V1GetProjectUsageApiCountInterval = {
  '15min': '15min',
  '30min': '30min',
  '1hr': '1hr',
  '3hr': '3hr',
  '1day': '1day',
  '3day': '3day',
  '7day': '7day',
} as const;

export type V1GetProjectFunctionCombinedStatsParams = {
interval: V1GetProjectFunctionCombinedStatsInterval;
function_id: string;
};

export type V1GetProjectFunctionCombinedStatsInterval = typeof V1GetProjectFunctionCombinedStatsInterval[keyof typeof V1GetProjectFunctionCombinedStatsInterval];


export const V1GetProjectFunctionCombinedStatsInterval = {
  '15min': '15min',
  '1hr': '1hr',
  '3hr': '3hr',
  '1day': '1day',
} as const;

export type V1RollbackMigrationsParams = {
/**
 * Rollback migrations greater or equal to this version
 * @pattern ^\d+$
 */
gte: string;
};

export type V1CreateAFunctionParams = {
/**
 * @pattern ^[A-Za-z0-9_-]+$
 */
slug?: string;
name?: string;
/**
 * Boolean string, true or false
 */
verify_jwt?: boolean;
/**
 * Boolean string, true or false
 */
import_map?: boolean;
entrypoint_path?: string;
import_map_path?: string;
ezbr_sha256?: string;
};

export type V1DeployAFunctionParams = {
/**
 * @pattern ^[A-Za-z][A-Za-z0-9_-]*$
 */
slug?: string;
/**
 * Boolean string, true or false
 */
bundleOnly?: boolean;
};

export type V1UpdateAFunctionParams = {
/**
 * @pattern ^[A-Za-z0-9_-]+$
 */
slug?: string;
name?: string;
/**
 * Boolean string, true or false
 */
verify_jwt?: boolean;
/**
 * Boolean string, true or false
 */
import_map?: boolean;
entrypoint_path?: string;
import_map_path?: string;
ezbr_sha256?: string;
};

export type V1GetRestorePointParams = {
/**
 * @maxLength 20
 */
name?: string;
};

export type V1GetAllProjectsForOrganizationParams = {
/**
 * Number of projects to skip
 * @minimum 0
 */
offset?: number;
/**
 * Number of projects to return per page
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * Search projects by name
 */
search?: string;
/**
 * Sort order for projects
 */
sort?: V1GetAllProjectsForOrganizationSort;
/**
 * A comma-separated list of project statuses to filter by.

The following values are supported: `ACTIVE_HEALTHY`, `INACTIVE`.
 */
statuses?: string;
};

export type V1GetAllProjectsForOrganizationSort = typeof V1GetAllProjectsForOrganizationSort[keyof typeof V1GetAllProjectsForOrganizationSort];


export const V1GetAllProjectsForOrganizationSort = {
  name_asc: 'name_asc',
  name_desc: 'name_desc',
  created_asc: 'created_asc',
  created_desc: 'created_desc',
} as const;

